const CATEGORIES = [
    { id: 'all', label: 'Tout', icon: 'apps', seo: '', count: 0 },
    { id: 'telecommande', label: 'Télécommandes', icon: 'settings_remote', seo: 'télécommande', count: 0 },
    { id: 'moteur_coul', label: 'Moteurs coulissants', icon: 'swap_horiz', seo: 'moteur coulissant', count: 0 },
    { id: 'moteur_batt', label: 'Moteurs battants', icon: 'sync_alt', seo: 'moteur battant', count: 0 },
    { id: 'photocellule', label: 'Photocellules', icon: 'sensors', seo: 'photocellule', count: 0 },
    { id: 'clavier', label: 'Claviers à code', icon: 'dialpad', seo: 'clavier à code', count: 0 },
    { id: 'centrale', label: 'Centrales', icon: 'developer_board', seo: 'centrale', count: 0 },
    { id: 'recepteur', label: 'Récepteurs', icon: 'wifi', seo: 'récepteur', count: 0 },
    { id: 'clignotant', label: 'Clignotants', icon: 'light', seo: 'clignotant', count: 0 },
    { id: 'moteur_garage', label: 'Portes de garage', icon: 'garage', seo: 'porte de garage', count: 0 },
];

const CAT_SEO = {};
const CAT_ICONS = {};
CATEGORIES.forEach(c => { CAT_SEO[c.id] = c.seo; CAT_ICONS[c.id] = c.icon; });

const DOCS = [
    { id: 'nice-on2e', brand: 'nice', cat: 'telecommande', family: 'ON',
      title: 'Nice ON2E', subtitle: '2 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'IS0046A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_on2e_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-on2e-2-boutons-pour-portail' },

    { id: 'nice-on4e', brand: 'nice', cat: 'telecommande', family: 'ON',
      title: 'Nice ON4E', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'IS0046A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_on4e_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-on4e-4-boutons-pour-portail' },

    { id: 'nice-on3ebd', brand: 'nice', cat: 'telecommande', family: 'ON',
      title: 'Nice ON3EBD', subtitle: '3 canaux · Bidirectionnel · Rolling code',
      tags: [['Bidirectionnel','purple'],['Rolling code','green'],['3 canaux','blue']],
      ref: 'IS0046A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_on3ebd_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-on3ebd-3-boutons-pour-portail' },

    { id: 'nice-on1e', brand: 'nice', cat: 'telecommande', family: 'ON',
      title: 'Nice ON1E', subtitle: '1 canal · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['1 canal','gray'],['433.92 MHz','gray']],
      ref: 'IS0243A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_on1e_nice.pdf',
      product: null },

    { id: 'nice-on9e', brand: 'nice', cat: 'telecommande', family: 'ON',
      title: 'Nice ON9E', subtitle: '9 canaux · Bidirectionnel · Rolling code',
      tags: [['Bidirectionnel','purple'],['Rolling code','green'],['9 canaux','blue']],
      ref: 'IS0243A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_on9e_nice.pdf',
      product: null },

    { id: 'nice-inti1', brand: 'nice', cat: 'telecommande', family: 'INTI',
      title: 'Nice ERA INTI1', subtitle: '1 canal · 433.92 MHz · O-Code · NiceOpera',
      tags: [['O-Code','green'],['1 canal','gray'],['NiceOpera','purple']],
      ref: 'IS0103A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_inti1_nice.pdf',
      product: null },

    { id: 'nice-inti2', brand: 'nice', cat: 'telecommande', family: 'INTI',
      title: 'Nice ERA INTI2', subtitle: '2 canaux · 433.92 MHz · O-Code · NiceOpera',
      tags: [['O-Code','green'],['2 canaux','gray'],['NiceOpera','purple']],
      ref: 'IS0103A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_inti2_nice.pdf',
      product: null },

    { id: 'nice-flo2re', brand: 'nice', cat: 'telecommande', family: 'FLO',
      title: 'Nice FLO2RE', subtitle: '2 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'IS0046A04FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_flo2re_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-flo2re-era-flor-2-boutons-pour-portail' },

    { id: 'nice-flo4re', brand: 'nice', cat: 'telecommande', family: 'FLO',
      title: 'Nice FLO4RE', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'IS0046A04FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_flo4re_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-flo4re-era-flor-4-boutons-pour-portail' },

    { id: 'nice-flo2', brand: 'nice', cat: 'telecommande', family: 'FLO',
      title: 'Nice FLO2', subtitle: '2 canaux · 433.92 MHz · Code fixe',
      tags: [['Code fixe','orange'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'MAN-FLO2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_flo2_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-flo2-2-boutons-pour-portail' },

    { id: 'nice-flo4', brand: 'nice', cat: 'telecommande', family: 'FLO',
      title: 'Nice FLO4', subtitle: '4 canaux · 433.92 MHz · Code fixe',
      tags: [['Code fixe','orange'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'MAN-FLO4',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_flo4_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-flo4-4-boutons-pour-portail' },

    { id: 'nice-flo2rs', brand: 'nice', cat: 'telecommande', family: 'FLO',
      title: 'Nice FLO2RS', subtitle: '2 canaux · 433.92 MHz · Code fixe',
      tags: [['Code fixe','orange'],['2 canaux','gray'],['DIP switch','gray']],
      ref: 'MAN-FLO2RS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_flo2rs_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-flo2rs-2-boutons-pour-portail' },

    { id: 'nice-mygo2', brand: 'nice', cat: 'telecommande', family: 'MYGO',
      title: 'Nice MYGO2', subtitle: '2 canaux · 433.92 MHz · O-Code',
      tags: [['O-Code','blue'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'IS0134A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mygo2_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-mygo2-2-boutons-pour-portail' },

    { id: 'nice-mygo4', brand: 'nice', cat: 'telecommande', family: 'MYGO',
      title: 'Nice MYGO4', subtitle: '4 canaux · 433.92 MHz · O-Code',
      tags: [['O-Code','blue'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'IS0134A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mygo4_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-mygo4-4-boutons-pour-portail' },

    { id: 'nice-mygo9', brand: 'nice', cat: 'telecommande', family: 'MYGO',
      title: 'Nice MYGO9', subtitle: '9 canaux · 433.92 MHz · O-Code',
      tags: [['O-Code','blue'],['9 canaux','blue'],['433.92 MHz','gray']],
      ref: 'IS0134A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mygo4_nice.pdf',
      product: null },

    { id: 'nice-ecco5bw', brand: 'nice', cat: 'telecommande', family: 'ECCO',
      title: 'Nice ECCO5 B/W', subtitle: '3 canaux · 433.92 MHz · O-Code',
      tags: [['O-Code','blue'],['3 canaux','blue'],['433.92 MHz','gray']],
      ref: 'IS0220A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ecco5bw_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-ecco5-4-boutons-pour-portail' },

    { id: 'nice-ecco5wo', brand: 'nice', cat: 'telecommande', family: 'ECCO',
      title: 'Nice ECCO5 W/O', subtitle: '3 canaux · 433.92 MHz · O-Code',
      tags: [['O-Code','blue'],['3 canaux','blue'],['433.92 MHz','gray']],
      ref: 'IS0220A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ecco5wo_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-nice-ecco5-blanche-orange-4-boutons-pour-portail' },

    { id: 'nice-mhouse-gtx4', brand: 'nice', cat: 'telecommande', family: 'Mhouse',
      title: 'Mhouse GTX4', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['Mhouse','gray']],
      ref: 'MAN-GTX4',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mhouse_gtx4_nice.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-mhouse-nice-gtx4-4-boutons-pour-portail' },

    { id: 'came-top432ee', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOP432EE', subtitle: '2 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: '806TS-0100',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_top432ee_came.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-came-top432ee-2-boutons-pour-portail' },

    { id: 'came-top44rbn', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOP44RBN', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: '806RV-0030',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_top44rbn_came.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-came-top44rbn-4-boutons-pour-portail' },

    { id: 'came-topd4frn', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOPD4FRN', subtitle: '4 canaux · 868.35 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['868 MHz','purple']],
      ref: '806RV-0080',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_topd4frn_came.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-came-topd4frn-4-boutons-pour-portail' },

    { id: 'came-top44fgn', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOP44FGN', subtitle: '4 canaux · 433.92 MHz · Code fixe',
      tags: [['Code fixe','orange'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: '001TOP-44FGN',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_top44fgn_came.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-came-top44fgn-4-boutons-pour-portail' },

    { id: 'came-top42fgn', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOP42FGN', subtitle: '2 canaux · 40.685 MHz · Code fixe',
      tags: [['Code fixe','orange'],['2 canaux','gray'],['40.685 MHz','gray']],
      ref: '001TOP-42FGN',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_top42fgn_came.pdf',
      product: 'https://portail-systeme.fr/products/telecommande-came-top42fgn-2-boutons-pour-portail' },

    { id: 'came-topd4ren', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOPD4REN', subtitle: '4 canaux · Bi-fréquence 433/868 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['Bi-fréquence','purple']],
      ref: '806TS-0290',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_topd4ren_came.pdf',
      product: null },



    { id: 'faac-xt2-433-slh', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT2 433 SLH', subtitle: '2 canaux · 433.92 MHz · Rolling code SLH',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433 MHz','gray'],['SLH','blue']],
      ref: 'XT2 433 SLH',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt2_433_slh_faac.pdf',
      product: null },

    { id: 'faac-xt4-433-slh', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT4 433 SLH', subtitle: '4 canaux · 433.92 MHz · Rolling code SLH',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433 MHz','gray'],['SLH','blue']],
      ref: 'XT4 433 SLH',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt4_433_slh_faac.pdf',
      product: null },

    { id: 'faac-xt2-868-slh', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT2 868 SLH', subtitle: '2 canaux · 868.35 MHz · Rolling code SLH',
      tags: [['Rolling code','green'],['2 canaux','gray'],['868 MHz','purple'],['SLH','blue']],
      ref: 'XT2 868 SLH',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt2_868_slh_faac.pdf',
      product: null },


    { id: 'somfy-keypop-2-rts', brand: 'somfy', cat: 'telecommande', family: 'Keypop',
      title: 'Somfy Keypop 2 RTS', subtitle: '2 canaux · 433.42 MHz · RTS',
      tags: [['RTS','green'],['2 canaux','gray'],['433.42 MHz','gray']],
      ref: 'Keypop 2 RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keypop_2_rts_somfy.pdf',
      product: null },

    { id: 'somfy-keygo-rts', brand: 'somfy', cat: 'telecommande', family: 'Keygo',
      title: 'Somfy Keygo RTS', subtitle: '4 canaux · 433.42 MHz · RTS',
      tags: [['RTS','green'],['4 canaux','blue'],['433.42 MHz','gray']],
      ref: 'Keygo 4 RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keygo_rts_somfy.pdf',
      product: null },

    { id: 'somfy-keygo-io', brand: 'somfy', cat: 'telecommande', family: 'Keygo',
      title: 'Somfy Keygo io', subtitle: '4 canaux · 868.95 MHz · io-homecontrol',
      tags: [['io','purple'],['4 canaux','blue'],['868 MHz','purple']],
      ref: 'Keygo io',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keygo_io_somfy.pdf',
      product: null },

    { id: 'somfy-keytis-2', brand: 'somfy', cat: 'telecommande', family: 'Keytis',
      title: 'Somfy Keytis 2 RTS', subtitle: '2 canaux · 433.42 MHz · RTS',
      tags: [['RTS','green'],['2 canaux','gray'],['433.42 MHz','gray']],
      ref: 'Keytis 2 RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keytis_2_somfy.pdf',
      product: null },

    { id: 'somfy-keytis-4', brand: 'somfy', cat: 'telecommande', family: 'Keytis',
      title: 'Somfy Keytis 4 RTS', subtitle: '4 canaux · 433.42 MHz · RTS',
      tags: [['RTS','green'],['4 canaux','blue'],['433.42 MHz','gray']],
      ref: 'Keytis 4 RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keytis_4_somfy.pdf',
      product: null },

    { id: 'somfy-keytis-4-io', brand: 'somfy', cat: 'telecommande', family: 'Keytis',
      title: 'Somfy Keytis 4 io', subtitle: '4 canaux · 868.95 MHz · io-homecontrol',
      tags: [['io','purple'],['4 canaux','blue'],['868 MHz','purple']],
      ref: 'Keytis 4 io',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keytis_4_io_somfy.pdf',
      product: null },

    { id: 'somfy-keytis-4-home-io', brand: 'somfy', cat: 'telecommande', family: 'Keytis',
      title: 'Somfy Keytis 4 Home io', subtitle: '4 canaux · 868.95 MHz · io-homecontrol · Home',
      tags: [['io','purple'],['4 canaux','blue'],['Home','green']],
      ref: 'Keytis 4 Home io',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keytis_4_home_io_somfy.pdf',
      product: null },

    { id: 'somfy-mitto', brand: 'somfy', cat: 'telecommande', family: 'Mitto',
      title: 'Somfy Mitto RTR', subtitle: '4 canaux · Émetteur RTR',
      tags: [['RTR','green'],['4 canaux','blue']],
      ref: 'Mitto RTR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mitto_somfy.pdf',
      product: null },

    { id: 'somfy-multi-app', brand: 'somfy', cat: 'telecommande', family: 'Multi',
      title: 'Somfy Télécommande multi-applications', subtitle: 'Multi-applications · RTS',
      tags: [['RTS','green'],['Multi-app','blue']],
      ref: 'Multi-applications',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_multi_app_somfy.pdf',
      product: null },

    { id: 'bft-mitto-b-rcb02', brand: 'bft', cat: 'telecommande', family: 'Mitto',
      title: 'BFT Mitto B RCB02', subtitle: '2 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'D111904',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mitto_b_rcb02_bft.pdf',
      product: null },

    { id: 'bft-mitto-b-rcb04', brand: 'bft', cat: 'telecommande', family: 'Mitto',
      title: 'BFT Mitto B RCB04', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'D111751',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mitto_b_rcb04_bft.pdf',
      product: null },


    { id: 'cardin-s449-qz2', brand: 'cardin', cat: 'telecommande', family: 'S449',
      title: 'Cardin S449 QZ2', subtitle: '2 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'TXQ4492P0',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s449_qz2_cardin.pdf',
      product: null },

    { id: 'cardin-s449-qz4', brand: 'cardin', cat: 'telecommande', family: 'S449',
      title: 'Cardin S449 QZ4', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'TXQ449400',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s449_qz4_cardin.pdf',
      product: null },

    { id: 'nice-robus400', brand: 'nice', cat: 'moteur_coul', family: 'Robus',
      title: 'Nice Robus 400 (RB400)', subtitle: '230V · Max 400kg · BlueBUS · Encodeur',
      tags: [['230V','orange'],['400 kg','gray'],['BlueBUS','blue'],['Encodeur','purple']],
      ref: 'IDV0629A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_robus400_nice.pdf',
      product: 'https://portail-systeme.fr/products/kit-motorisation-nice-robus-400-portail-coulissant-rbs400bdkce' },

    { id: 'nice-robus600', brand: 'nice', cat: 'moteur_coul', family: 'Robus',
      title: 'Nice Robus 600 (RB600)', subtitle: '230V · Max 600kg · BlueBUS · Encodeur',
      tags: [['230V','orange'],['600 kg','gray'],['BlueBUS','blue'],['Encodeur','purple']],
      ref: 'IDV0629A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_robus400_nice.pdf',
      product: 'https://portail-systeme.fr/products/kit-motorisation-nice-robus-600-portail-coulissant-rbs600bdkce' },

    { id: 'nice-robus1000', brand: 'nice', cat: 'moteur_coul', family: 'Robus',
      title: 'Nice Robus 1000 (RB1000)', subtitle: '230V · Max 1000kg · BlueBUS · Encodeur',
      tags: [['230V','orange'],['1000 kg','gray'],['BlueBUS','blue'],['Encodeur','purple']],
      ref: 'IDV0629A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_robus400_nice.pdf',
      product: null },

    { id: 'nice-road400', brand: 'nice', cat: 'moteur_coul', family: 'Road',
      title: 'Nice Road 400 (RD400)', subtitle: '230V · Max 400kg · BlueBUS',
      tags: [['230V','orange'],['400 kg','gray'],['BlueBUS','blue']],
      ref: 'IDV0615A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_road400_nice.pdf',
      product: null },

    { id: 'came-bx74', brand: 'came', cat: 'moteur_coul', family: 'BX',
      title: 'CAME BX-74', subtitle: '230V · Max 400kg · Résidentiel',
      tags: [['230V','orange'],['400 kg','gray'],['Résidentiel','green']],
      ref: 'FA00127-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bx74_came.pdf',
      product: null },

    { id: 'came-bx78', brand: 'came', cat: 'moteur_coul', family: 'BX',
      title: 'CAME BX-78', subtitle: '230V · Max 800kg · Résidentiel & Collectif',
      tags: [['230V','orange'],['800 kg','gray'],['Collectif','blue']],
      ref: 'FA00127-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bx78_came.pdf',
      product: null },

    { id: 'came-bx243', brand: 'came', cat: 'moteur_coul', family: 'BX',
      title: 'CAME BX-243', subtitle: '24V · Max 400kg · Encodeur',
      tags: [['24V','green'],['400 kg','gray'],['Encodeur','purple']],
      ref: '119BU30',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bx243_came.pdf',
      product: null },

    { id: 'came-bx246', brand: 'came', cat: 'moteur_coul', family: 'BX',
      title: 'CAME BX-246', subtitle: '24V · Max 400kg · Batterie intégrée',
      tags: [['24V','green'],['400 kg','gray'],['Batterie','purple']],
      ref: 'FA00668-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bx246_came.pdf',
      product: null },

    { id: 'came-bx324', brand: 'came', cat: 'moteur_coul', family: 'BX',
      title: 'CAME BX-324 / BX-324V', subtitle: '230V · Max 400kg',
      tags: [['230V','orange'],['400 kg','gray']],
      ref: '119BV10',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bx324_came.pdf',
      product: null },

    { id: 'came-bxv', brand: 'came', cat: 'moteur_coul', family: 'BXV',
      title: 'CAME BXV · Série complète', subtitle: '24V · Max 600-1000kg · Écran · Encodeur',
      tags: [['24V','green'],['1000 kg','gray'],['Encodeur','purple'],['Écran','blue']],
      ref: 'FA01442-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bxv_came.pdf',
      product: null },

    { id: 'came-bk1200', brand: 'came', cat: 'moteur_coul', family: 'BK',
      title: 'CAME BK-1200', subtitle: '230V · Max 1200kg · Industriel',
      tags: [['230V','orange'],['1200 kg','gray'],['Industriel','purple']],
      ref: '119BS04FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bk1200_came.pdf',
      product: null },

    { id: 'came-bk1200p', brand: 'came', cat: 'moteur_coul', family: 'BK',
      title: 'CAME BK-1200P', subtitle: '230V · Max 1200kg · Pratico System',
      tags: [['230V','orange'],['1200 kg','gray'],['Pratico','green']],
      ref: 'FA00605-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bk1200p_came.pdf',
      product: null },

    { id: 'nice-popkit', brand: 'nice', cat: 'moteur_batt', family: 'PopKit',
      title: 'Nice PopKit (POP7124)', subtitle: '24V · Max 3.5m/vantail · BlueBUS',
      tags: [['24V','green'],['3.5m','gray'],['BlueBUS','blue']],
      ref: 'IDV0668A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_popkit_nice.pdf',
      product: 'https://portail-systeme.fr/products/kit-motorisation-nice-popkit-portail-battant-pop7124kce' },

    { id: 'nice-toona', brand: 'nice', cat: 'moteur_batt', family: 'Toona',
      title: 'Nice Toona (TO4024 / TO5024)', subtitle: '24V · Max 3.5m/vantail · Irréversible',
      tags: [['24V','green'],['3.5m','gray'],['Irréversible','orange']],
      ref: 'ISTTOR02.4865',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_toona_nice.pdf',
      product: 'https://portail-systeme.fr/products/kit-motorisation-nice-toona-portail-battant-2-vantaux-toona4024bdkce' },

    { id: 'nice-wingo', brand: 'nice', cat: 'moteur_batt', family: 'Wingo',
      title: 'Nice Wingo (WG4024 / WG5024)', subtitle: '24V · Max 3.5m/vantail · Réversible',
      tags: [['24V','green'],['3.5m','gray'],['Réversible','blue']],
      ref: 'ISTWINGOR02.4865',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_wingo_nice.pdf',
      product: null },

    { id: 'nice-hyppo', brand: 'nice', cat: 'moteur_batt', family: 'Hyppo',
      title: 'Nice Hyppo (HO7124 / HO7224)', subtitle: '24V · Max 3.5m/vantail · BlueBUS',
      tags: [['24V','green'],['3.5m','gray'],['BlueBUS','blue']],
      ref: 'IDV0657A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_hyppo_nice.pdf',
      product: null },

    { id: 'nice-hykekit', brand: 'nice', cat: 'moteur_batt', family: 'Hyke',
      title: 'Nice HYKEKIT (HK7024 / HK7224)', subtitle: '24V · Max 3m/vantail · BlueBUS · OPERA',
      tags: [['24V','green'],['3m','gray'],['BlueBUS','blue'],['OPERA','purple']],
      ref: 'IDV0670A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_hykekit_nice.pdf',
      product: null },

    { id: 'came-frog', brand: 'came', cat: 'moteur_batt', family: 'FROG',
      title: 'CAME FROG-A / FROG-AE', subtitle: '230V · Max 3.5m · Enterré · Irréversible',
      tags: [['230V','orange'],['3.5m','gray'],['Enterré','purple'],['Irréversible','orange']],
      ref: 'FA01316-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_frog_came.pdf',
      product: null },

    { id: 'came-axo230', brand: 'came', cat: 'moteur_batt', family: 'AXO',
      title: 'CAME AXO 230V', subtitle: '230V · Max 3m · Vis sans fin · Encodeur',
      tags: [['230V','orange'],['3m','gray'],['Vis sans fin','blue'],['Encodeur','purple']],
      ref: '119DU85',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_axo230_came.pdf',
      product: null },

    { id: 'came-axo24', brand: 'came', cat: 'moteur_batt', family: 'AXO',
      title: 'CAME AXO 24V (AX3024 / AX5024)', subtitle: '24V · Max 3m · Vis sans fin · Encodeur',
      tags: [['24V','green'],['3m','gray'],['Vis sans fin','blue'],['Encodeur','purple']],
      ref: '119DU86FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_axo24_came.pdf',
      product: null },

    { id: 'came-fast', brand: 'came', cat: 'moteur_batt', family: 'FAST',
      title: 'CAME FAST (FA70230CB)', subtitle: '230V · Max 2.3m · Rapide',
      tags: [['230V','orange'],['2.3m','gray'],['Rapide','green']],
      ref: 'FA00094-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_fast_came.pdf',
      product: null },

    { id: 'nice-mof', brand: 'nice', cat: 'photocellule', family: 'MOF',
      title: 'Nice MOF / MOFO', subtitle: 'Orientable · Infrarouge · 4 fils',
      tags: [['Infrarouge','orange'],['4 fils','gray'],['Orientable','blue']],
      ref: 'ISTFM.4854',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mof_nice.pdf',
      product: null },

    { id: 'nice-mofb', brand: 'nice', cat: 'photocellule', family: 'MOF',
      title: 'Nice MOFB / MOFOB', subtitle: 'BlueBUS · Infrarouge · 2 fils',
      tags: [['BlueBUS','blue'],['Infrarouge','orange'],['2 fils','green']],
      ref: 'IS0262A01MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mofb_nice.pdf',
      product: null },

    { id: 'nice-epmb', brand: 'nice', cat: 'photocellule', family: 'EPM',
      title: 'Nice EPMB', subtitle: 'BlueBUS nouvelle génération · 15m portée',
      tags: [['BlueBUS','blue'],['15m','gray'],['Nouvelle gen.','green']],
      ref: 'IS0339A04MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_epmb_nice.pdf',
      product: null },

    { id: 'came-dir', brand: 'came', cat: 'photocellule', family: 'DIR',
      title: 'CAME DIR10 / DIR20 / DIR30', subtitle: 'Synchronisées · Infrarouge · 12/24V',
      tags: [['Infrarouge','orange'],['12/24V','green'],['Synchronisées','blue']],
      ref: '119RS11',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dir_came.pdf',
      product: null },

    { id: 'nice-edswg', brand: 'nice', cat: 'clavier', family: 'EDS',
      title: 'Nice EDSWG', subtitle: 'Radio · 3 canaux · 433.92 MHz · Rolling code',
      tags: [['Radio','purple'],['Rolling code','green'],['3 canaux','blue']],
      ref: 'IS0339A04MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_edswg_nice.pdf',
      product: null },

    { id: 'nice-mc824h', brand: 'nice', cat: 'centrale', family: 'MC',
      title: 'Nice MC824H', subtitle: 'Centrale battants · BlueBUS · BusT4',
      tags: [['Battants','blue'],['BlueBUS','blue'],['BusT4','purple']],
      ref: 'IDV0606A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mc824h_nice.pdf',
      product: null },

    { id: 'nice-mc424l', brand: 'nice', cat: 'centrale', family: 'MC',
      title: 'Nice MC424L', subtitle: 'Centrale 24V · Wingo/Toona/SFAB',
      tags: [['24V','green'],['Battants','blue'],['Radio intégré','purple']],
      ref: 'IDV0619A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mc424l_nice.pdf',
      product: null },

    { id: 'came-za3p', brand: 'came', cat: 'centrale', family: 'ZA',
      title: 'CAME ZA3P', subtitle: 'Centrale battants 230V · ATI/FROG/FAST',
      tags: [['230V','orange'],['Battants','blue'],['Multifonctions','green']],
      ref: '319W86',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_za3p_came.pdf',
      product: null },

    { id: 'came-zm3e', brand: 'came', cat: 'centrale', family: 'ZM',
      title: 'CAME ZM3E / ZM3EP / ZM3EC', subtitle: 'Centrale battants · Écran · Autodiagnostic',
      tags: [['Battants','blue'],['Écran','purple'],['Autodiagnostic','green']],
      ref: 'FA01080-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_zm3e_came.pdf',
      product: null },

    { id: 'came-zlj24', brand: 'came', cat: 'centrale', family: 'ZL',
      title: 'CAME ZLJ24', subtitle: 'Centrale 24V · AXO/FROG · Encodeur',
      tags: [['24V','green'],['Battants','blue'],['Encodeur','purple']],
      ref: 'FA00038-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_zlj24_came.pdf',
      product: null },

    { id: 'nice-run1500', brand: 'nice', cat: 'moteur_coul', family: 'Run',
      title: 'Nice RUN 1500 / 1800 / 2500', subtitle: '24V · Max 500-2500kg · BlueBUS · Encodeur',
      tags: [['24V','green'],['2500 kg','gray'],['BlueBUS','blue'],['Encodeur','purple']],
      ref: 'IDV0659A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_run1500_nice.pdf',
      product: null },

    { id: 'nice-run400hs', brand: 'nice', cat: 'moteur_coul', family: 'Run',
      title: 'Nice RUN 400HS / 1200HS', subtitle: '24V · Hi-Speed · BlueBUS · Encodeur',
      tags: [['24V','green'],['Hi-Speed','orange'],['BlueBUS','blue'],['Encodeur','purple']],
      ref: 'IDV0659A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_run1500_nice.pdf',
      product: null },

    { id: 'nice-slh400', brand: 'nice', cat: 'moteur_coul', family: 'SLH',
      title: 'Nice SLH400', subtitle: '230V · Max 400kg · BlueBUS',
      tags: [['230V','orange'],['400 kg','gray'],['BlueBUS','blue']],
      ref: 'IDV0635A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slh400_nice.pdf',
      product: null },

    { id: 'nice-robus250hs', brand: 'nice', cat: 'moteur_coul', family: 'Robus',
      title: 'Nice Robus 250HS / 500HS', subtitle: '24V · Hi-Speed · BlueBUS · Encodeur',
      tags: [['24V','green'],['Hi-Speed','orange'],['BlueBUS','blue'],['Encodeur','purple']],
      ref: 'IDV0629A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_robus250hs_nice.pdf',
      product: null },

    { id: 'nice-filo400', brand: 'nice', cat: 'moteur_coul', family: 'FILO',
      title: 'Nice FILO 400', subtitle: '24V · Max 400kg · NiceHome · Encodeur',
      tags: [['24V','green'],['400 kg','gray'],['NiceHome','purple']],
      ref: 'IS0468A02MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_filo_nice.pdf',
      product: null },

    { id: 'nice-filo600', brand: 'nice', cat: 'moteur_coul', family: 'FILO',
      title: 'Nice FILO 600', subtitle: '24V · Max 600kg · NiceHome · Encodeur',
      tags: [['24V','green'],['600 kg','gray'],['NiceHome','purple']],
      ref: 'IS0468A02MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_filo_nice.pdf',
      product: null },

    { id: 'nice-dritto', brand: 'nice', cat: 'moteur_coul', family: 'DRITTO',
      title: 'Nice DRITTO', subtitle: '24V · NiceHome · Nouvelle génération · Coulissant',
      tags: [['24V','green'],['NiceHome','purple'],['Nouvelle gén.','blue']],
      ref: 'IS0964A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dritto_nice.pdf',
      product: null },

    { id: 'nice-in100', brand: 'nice', cat: 'moteur_batt', family: 'IN',
      title: 'Nice IN100', subtitle: 'Intégré · Battant · 24V · Max 1.8m',
      tags: [['24V','green'],['1.8m','gray'],['Intégré','purple']],
      ref: 'IS0523A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_in100_nice.pdf',
      product: null },

    { id: 'nice-dpro924', brand: 'nice', cat: 'centrale', family: 'DPRO',
      title: 'Nice DPRO924', subtitle: 'Centrale 24V · Portails coulissants · Encodeur',
      tags: [['24V','green'],['Coulissant','blue'],['Encodeur','purple']],
      ref: 'IS0662A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dpro924_nice.pdf',
      product: null },

    { id: 'nice-oxi-ox2', brand: 'nice', cat: 'recepteur', family: 'OXI',
      title: 'Nice OXI / OX2', subtitle: 'Récepteur embrochable · 433.92 MHz · 4 canaux',
      tags: [['433.92 MHz','gray'],['4 canaux','blue'],['Embrochable','green']],
      ref: 'OXI-OX2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_oxi_ox2_nice.pdf',
      product: null },

    { id: 'nice-oxibd', brand: 'nice', cat: 'recepteur', family: 'OXI',
      title: 'Nice OXIBD', subtitle: 'Récepteur bidirectionnel · 433.92 MHz · BusT4',
      tags: [['Bidirectionnel','purple'],['433.92 MHz','gray'],['BusT4','blue']],
      ref: 'IDV0603A01FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_oxibd_nice.pdf',
      product: null },

    { id: 'nice-smxi', brand: 'nice', cat: 'recepteur', family: 'SMXI',
      title: 'Nice SMXI', subtitle: 'Récepteur embrochable · 433.92 MHz · Rolling code · 256 codes',
      tags: [['Rolling code','green'],['433.92 MHz','gray'],['256 codes','blue']],
      ref: 'SMXI',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_smxi_nice.pdf',
      product: null },

    { id: 'came-af43s', brand: 'came', cat: 'recepteur', family: 'AF',
      title: 'CAME AF43S / AF868', subtitle: 'Carte radio embrochable · 433.92 / 868.35 MHz',
      tags: [['433.92 MHz','gray'],['868 MHz','purple'],['Embrochable','green']],
      ref: 'FA01703M4A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_af43s_came.pdf',
      product: null },

    { id: 'came-rbe4n', brand: 'came', cat: 'recepteur', family: 'RBE',
      title: 'CAME RBE4N', subtitle: 'Récepteur radio · 4 canaux · 12/24V',
      tags: [['4 canaux','blue'],['12/24V','green'],['Externe','gray']],
      ref: 'RBE4N',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rbe4n_came.pdf',
      product: null },

    { id: 'came-zbx6n', brand: 'came', cat: 'moteur_coul', family: 'ZBX',
      title: 'CAME ZBX6N / ZBX7N', subtitle: 'Centrale coulissant 230V · BX-74/78',
      tags: [['230V','orange'],['Coulissant','blue'],['BX-74/78','gray']],
      ref: 'ZBX6N-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_zbx6n_came.pdf',
      product: null },

    { id: 'nice-spin-bus', brand: 'nice', cat: 'moteur_garage', family: 'SPIN',
      title: 'Nice SPIN / SPINbus (SN6021/SN6031/SN6041)', subtitle: '230V · Sectionnelle/Basculante · BlueBUS',
      tags: [['230V','orange'],['Sectionnelle','blue'],['BlueBUS','blue']],
      ref: 'IDV0614A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_spin_bus_nice.pdf',
      product: null },

    { id: 'nice-spin-new', brand: 'nice', cat: 'moteur_garage', family: 'SPIN',
      title: 'Nice SPIN nouvelle génération', subtitle: '230V · Sectionnelle/Basculante · OXI',
      tags: [['230V','orange'],['Sectionnelle','blue'],['OXI','green']],
      ref: 'IDV0613A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_spin_new_nice.pdf',
      product: null },

    { id: 'nice-spido', brand: 'nice', cat: 'moteur_garage', family: 'SPIDO',
      title: 'Nice SPIDO', subtitle: '24V · Sectionnelle/Basculante · BlueBUS',
      tags: [['24V','green'],['Sectionnelle','blue'],['BlueBUS','blue']],
      ref: 'IDV0564A02FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_spido_nice.pdf',
      product: null },

    { id: 'nice-spin3040', brand: 'nice', cat: 'moteur_garage', family: 'SPIN',
      title: 'Nice SPIN30 / SPIN40 (anciennes versions)', subtitle: '230V · Courroie · SMXI',
      tags: [['230V','orange'],['Courroie','gray'],['SMXI','green']],
      ref: 'SPIN-30-40',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_spin3040_nice.pdf',
      product: null },

    { id: 'came-ver06-08', brand: 'came', cat: 'moteur_garage', family: 'VER',
      title: 'CAME VER06DES / VER08DES', subtitle: '24V · Encodeur · Sectionnelle/Basculante',
      tags: [['24V','green'],['Encodeur','purple'],['Sectionnelle','blue']],
      ref: 'FA01176-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ver06_08_came.pdf',
      product: null },

    { id: 'came-ver10-13', brand: 'came', cat: 'moteur_garage', family: 'VER',
      title: 'CAME VER10DMS / VER13DMS', subtitle: '24V · Encodeur · Nouvelle génération',
      tags: [['24V','green'],['Encodeur','purple'],['Nouvelle gen.','green']],
      ref: 'FA01768-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ver10_13_came.pdf',
      product: null },

    { id: 'came-v6000', brand: 'came', cat: 'moteur_garage', family: 'V6000',
      title: 'CAME V6000', subtitle: '24V · Chaîne/Courroie · Résidentiel',
      tags: [['24V','green'],['Chaîne','gray'],['Résidentiel','green']],
      ref: 'FA00047-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_v6000_came.pdf',
      product: null },

    { id: 'nice-spy', brand: 'nice', cat: 'moteur_garage', family: 'SPY',
      title: 'Nice SPY550 / SPY650 / SPY800', subtitle: '24V · Sectionnelle/Basculante · BlueBUS',
      tags: [['24V','green'],['800N','gray'],['BlueBUS','blue']],
      ref: 'IDV0385A03FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_spy_nice.pdf',
      product: null },

    { id: 'came-krono', brand: 'came', cat: 'moteur_batt', family: 'KRONO',
      title: 'CAME KRONO (KR300/KR310/KR510)', subtitle: '230V · Irréversible · Max 3-5m/vantail',
      tags: [['230V','orange'],['5m','gray'],['Irréversible','purple']],
      ref: 'FA00290-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_krono_came.pdf',
      product: null },

    { id: 'came-ati', brand: 'came', cat: 'moteur_batt', family: 'ATI',
      title: 'CAME ATI (A3000A/A5000A)', subtitle: '230V · Vérin · Max 3-5m/vantail',
      tags: [['230V','orange'],['Vérin','blue'],['5m','gray']],
      ref: '119DS55',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ati_came.pdf',
      product: null },

    { id: 'came-fast70', brand: 'came', cat: 'moteur_batt', family: 'FAST',
      title: 'CAME FAST70 (FA70230CB)', subtitle: '230V · Rapide · Max 2.3m/vantail',
      tags: [['230V','orange'],['Rapide','green'],['2.3m','gray']],
      ref: 'FA00094-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_fast70_came.pdf',
      product: null },

    { id: 'came-stylo', brand: 'came', cat: 'moteur_batt', family: 'STYLO',
      title: 'CAME STYLO', subtitle: '230V · Externe · Bras articulé',
      tags: [['230V','orange'],['Externe','blue'],['Bras articulé','gray']],
      ref: 'STYLO-RME',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_stylo_came.pdf',
      product: null },

    { id: 'came-ops001', brand: 'came', cat: 'moteur_coul', family: 'OPS',
      title: 'CAME OPS001', subtitle: '230V · Coulissant · Encodeur',
      tags: [['230V','orange'],['Encodeur','purple'],['Résidentiel','green']],
      ref: '119BW70FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ops001_came.pdf',
      product: null },

    { id: 'came-za3n', brand: 'came', cat: 'centrale', family: 'ZA',
      title: 'CAME ZA3N', subtitle: 'Centrale 230V · ATI/FROG/FAST/KRONO/FERNI',
      tags: [['230V','orange'],['Battants','blue'],['Multifonctions','green']],
      ref: 'ZA3N',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_za3n_came.pdf',
      product: null },

    { id: 'came-zf1n', brand: 'came', cat: 'centrale', family: 'ZF',
      title: 'CAME ZF1N / ZF1N110', subtitle: 'Centrale 230V · Battants · DIP switches',
      tags: [['230V','orange'],['Battants','blue'],['DIP','gray']],
      ref: 'FA00679-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_zf1n_came.pdf',
      product: null },

    { id: 'nice-walky', brand: 'nice', cat: 'moteur_batt', family: 'Walky',
      title: 'Nice WALKY (WL1024)', subtitle: '24V · Portillon/Battant · BlueBUS · Max 1.8m',
      tags: [['24V','green'],['1.8m','gray'],['BlueBUS','blue']],
      ref: 'IS0489A01MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_walky_nice.pdf',
      product: null },

    { id: 'came-ferni', brand: 'came', cat: 'moteur_batt', family: 'FERNI',
      title: 'CAME FERNI (F1000/F1100)', subtitle: '230V · Bras articulé · Max 4m/vantail',
      tags: [['230V','orange'],['4m','gray'],['Irréversible','purple']],
      ref: 'F1000-F1100',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ferni_came.pdf',
      product: null },

    { id: 'came-ferni-new', brand: 'came', cat: 'moteur_batt', family: 'FERNI',
      title: 'CAME FERNI nouvelle gén. (FE40230)', subtitle: '230V · Bras articulé · ZM3E',
      tags: [['230V','orange'],['Nouvelle gen.','green'],['ZM3E','blue']],
      ref: 'FE40230',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ferni_new_came.pdf',
      product: null },

    { id: 'nice-sfab', brand: 'nice', cat: 'moteur_batt', family: 'SFAB',
      title: 'Nice SFAB2024 / SFAB2124', subtitle: '24V · Enterré · IP67 · Max 2.4m/vantail',
      tags: [['24V','green'],['Enterré','purple'],['IP67','blue']],
      ref: 'SFAB2024',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sfab_nice.pdf',
      product: null },

    { id: 'nice-aria200', brand: 'nice', cat: 'moteur_batt', family: 'ARIA',
      title: 'Nice ARIA 200', subtitle: '24V · NiceHome · Battant · Max 200kg/vantail',
      tags: [['24V','green'],['NiceHome','purple'],['200 kg','gray']],
      ref: 'IS0638B00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_aria_nice.pdf',
      product: null },

    { id: 'nice-aria400', brand: 'nice', cat: 'moteur_batt', family: 'ARIA',
      title: 'Nice ARIA 400', subtitle: '24V · NiceHome · Battant · Max 400kg/vantail',
      tags: [['24V','green'],['NiceHome','purple'],['400 kg','gray']],
      ref: 'IS0638B00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_aria_nice.pdf',
      product: null },

    { id: 'came-frog-a', brand: 'came', cat: 'moteur_batt', family: 'FROG',
      title: 'CAME FROG-A / FROG-AV / FROG-AE', subtitle: '230V · Enterré · IP67 · Max 3.5m',
      tags: [['230V','orange'],['Enterré','purple'],['IP67','blue']],
      ref: 'FA01316-FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_frog_a_came.pdf',
      product: null },

    { id: 'came-frog-j', brand: 'came', cat: 'moteur_batt', family: 'FROG',
      title: 'CAME FROG-J', subtitle: '230V · Enterré · IP67 · Usage intensif',
      tags: [['230V','orange'],['Enterré','purple'],['Intensif','orange']],
      ref: '119AU14FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_frog_j_came.pdf',
      product: null },

    { id: 'came-frog-a24', brand: 'came', cat: 'moteur_batt', family: 'FROG',
      title: 'CAME FROG-A24 / FROG-A24E', subtitle: '24V · Enterré · Max 3.5m · 400kg',
      tags: [['24V','green'],['Enterré','purple'],['400kg','gray']],
      ref: '119AU35',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_frog_a24_came.pdf',
      product: null },

    { id: 'cardin-s486-qz2', brand: 'cardin', cat: 'telecommande', family: 'S486',
      title: 'Cardin S486 QZ2', subtitle: '2 canaux · 868.35 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['868 MHz','purple']],
      ref: 'TXQ486200',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s486_qz2_cardin.pdf',
      product: null },

    { id: 'cardin-s486-qz4', brand: 'cardin', cat: 'telecommande', family: 'S486',
      title: 'Cardin S486 QZ4', subtitle: '4 canaux · 868.35 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['868 MHz','purple']],
      ref: 'TRQ486400',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s486_qz4_cardin.pdf',
      product: null },

    { id: 'cardin-s504-c2', brand: 'cardin', cat: 'telecommande', family: 'S504',
      title: 'Cardin S504 C2', subtitle: '2 canaux · 433.92 MHz · Rolling code 128 bits',
      tags: [['128 bits','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'TXQ504C2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s504_c2_cardin.pdf',
      product: null },

    { id: 'cardin-s504-c4', brand: 'cardin', cat: 'telecommande', family: 'S504',
      title: 'Cardin S504 C4', subtitle: '4 canaux · 433.92 MHz · Rolling code 128 bits',
      tags: [['128 bits','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'TXQ504C4',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s504_c4_cardin.pdf',
      product: null },

    { id: 'cardin-s508-c2', brand: 'cardin', cat: 'telecommande', family: 'S508',
      title: 'Cardin S508 C2', subtitle: '2 canaux · 868 MHz · Rolling code 128 bits',
      tags: [['128 bits','green'],['2 canaux','gray'],['868 MHz','purple']],
      ref: 'TXQ508C2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s508_c2_cardin.pdf',
      product: null },

    { id: 'cardin-s508-c4', brand: 'cardin', cat: 'telecommande', family: 'S508',
      title: 'Cardin S508 C4', subtitle: '4 canaux · 868 MHz · Rolling code 128 bits',
      tags: [['128 bits','green'],['4 canaux','blue'],['868 MHz','purple']],
      ref: 'TXQ508C4',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s508_c4_cardin.pdf',
      product: null },

    { id: 'cardin-s476-tx2', brand: 'cardin', cat: 'telecommande', family: 'S476',
      title: 'Cardin S476 TX2', subtitle: '2 canaux · 433.92 MHz · Code fixe DIP switch',
      tags: [['Code fixe','orange'],['2 canaux','gray'],['DIP switch','gray']],
      ref: 'TRS476200',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s476_tx2_cardin.pdf',
      product: null },

    { id: 'cardin-s476-tx4', brand: 'cardin', cat: 'telecommande', family: 'S476',
      title: 'Cardin S476 TX4', subtitle: '4 canaux · 433.92 MHz · Code fixe DIP switch',
      tags: [['Code fixe','orange'],['4 canaux','blue'],['DIP switch','gray']],
      ref: 'TRS476400',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s476_tx4_cardin.pdf',
      product: null },

    { id: 'cardin-s435-tx4', brand: 'cardin', cat: 'telecommande', family: 'S435',
      title: 'Cardin S435 TX4', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'TRS435400',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s435_tx4_cardin.pdf',
      product: null },

    { id: 'cardin-rcq449', brand: 'cardin', cat: 'recepteur', family: 'RCQ',
      title: 'Cardin RCQ449 ND', subtitle: 'Récepteur 433.92 MHz · 4 canaux · 300 codes',
      tags: [['433.92 MHz','gray'],['4 canaux','blue'],['300 codes','green']],
      ref: 'RCQ449D00',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rcq449_cardin.pdf',
      product: null },

    { id: 'cardin-rsq449', brand: 'cardin', cat: 'recepteur', family: 'RSQ',
      title: 'Cardin RSQ449', subtitle: 'Récepteur 433.92 MHz · 2 canaux · Coffret',
      tags: [['433.92 MHz','gray'],['2 canaux','gray'],['Coffret','blue']],
      ref: 'RSQ449200',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rsq449_cardin.pdf',
      product: null },

    { id: 'cardin-rqm449', brand: 'cardin', cat: 'recepteur', family: 'RQM',
      title: 'Cardin RQM449', subtitle: 'Mini récepteur 433.92 MHz · 2 canaux · Enfichable',
      tags: [['433.92 MHz','gray'],['2 canaux','gray'],['Mini','green']],
      ref: 'RQM449200',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rqm449_cardin.pdf',
      product: null },

    { id: 'cardin-rqm504c2', brand: 'cardin', cat: 'recepteur', family: 'RQM',
      title: 'Cardin RQM504 C2', subtitle: 'Mini récepteur 433.92 MHz · 2 canaux · S504',
      tags: [['433.92 MHz','gray'],['2 canaux','gray'],['S504','green']],
      ref: 'RQM504C2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rqm504c2_cardin.pdf',
      product: null },

    { id: 'cardin-rqm508c2', brand: 'cardin', cat: 'recepteur', family: 'RQM',
      title: 'Cardin RQM508 C2', subtitle: 'Mini récepteur 868 MHz · 2 canaux · S508',
      tags: [['868 MHz','purple'],['2 canaux','gray'],['S508','green']],
      ref: 'RQM508C2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rqm508c2_cardin.pdf',
      product: null },

    { id: 'cardin-sl1524', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL1524', subtitle: '24V · Max 1500kg · Encodeur intégré',
      tags: [['24V','green'],['1500 kg','gray'],['Encodeur','purple']],
      ref: 'ZVL427',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl1524_cardin.pdf',
      product: null },

    { id: 'cardin-slx3024', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SLX3024', subtitle: '24V · Max 3000kg · Encodeur intégré',
      tags: [['24V','green'],['3000 kg','gray'],['Encodeur','purple']],
      ref: 'SLX3024CB',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slx3024_cardin.pdf',
      product: null },

    { id: 'cardin-bl3924', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL3924', subtitle: '24V · Bras articulé · Encodeur intégré',
      tags: [['24V','green'],['Bras articulé','purple'],['Encodeur','blue']],
      ref: 'BL3924MCB',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl3924_cardin.pdf',
      product: null },

    { id: 'cardin-bl1924', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL1924', subtitle: '24V · Bras articulé · Encodeur intégré',
      tags: [['24V','green'],['Bras articulé','purple'],['Encodeur','blue']],
      ref: 'BL1924ASW',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl1924_cardin.pdf',
      product: null },

    { id: 'cardin-bl824m', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL824M', subtitle: '24V · Autobloquant · Bras · Encodeur intégré',
      tags: [['24V','green'],['Autobloquant','purple'],['Encodeur','blue']],
      ref: 'ZVL517',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl824m_cardin.pdf',
      product: null },

    { id: 'cardin-hl-enterre', brand: 'cardin', cat: 'moteur_batt', family: 'HL',
      title: 'Cardin HL2524 / HL824', subtitle: '24V · Enterré · Battant',
      tags: [['24V','green'],['Enterré','purple'],['Battant','blue']],
      ref: 'ZVL480',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_hl_enterre_cardin.pdf',
      product: null },

    { id: 'cardin-slx824', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SLX824', subtitle: '24V · Max 800kg · LCD display · Firmware V140',
      tags: [['24V','green'],['800 kg','gray'],['LCD','purple']],
      ref: 'SLX824CB',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slx824_cardin.pdf',
      product: null },

    { id: 'cardin-slx1024rev', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SLX1024 REV', subtitle: '24V · Réversible · Max 1000kg · LCD display',
      tags: [['24V','green'],['1000 kg','gray'],['Réversible','purple']],
      ref: 'SLX1024REV',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slx1024rev_cardin.pdf',
      product: null },

    { id: 'cardin-slx24draco', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SLX24 DRACO', subtitle: '24V · Max 1000kg · LCD display · Firmware V140',
      tags: [['24V','green'],['1000 kg','gray'],['LCD','purple']],
      ref: 'SLX24DRACO',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slx24draco_cardin.pdf',
      product: null },

    { id: 'cardin-slx24draco2', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SLX24 DRACO2', subtitle: '24V · Max 2000kg · LCD display · Firmware V140',
      tags: [['24V','green'],['2000 kg','gray'],['LCD','purple']],
      ref: 'SLX24DRACO2',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slx24draco_cardin.pdf',
      product: null },

    { id: 'cardin-sl-ace401', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-ACE401', subtitle: '24V · Max 400kg · Motoréducteur',
      tags: [['24V','green'],['400 kg','gray'],['ACE','purple']],
      ref: 'SL-ACE401',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_ace_cardin.pdf',
      product: null },

    { id: 'cardin-sl-ace601', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-ACE601', subtitle: '24V · Max 600kg · Motoréducteur',
      tags: [['24V','green'],['600 kg','gray'],['ACE','purple']],
      ref: 'SL-ACE601',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_ace_cardin.pdf',
      product: null },

    { id: 'cardin-sl-ace801', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-ACE801', subtitle: '24V · Max 800kg · Motoréducteur',
      tags: [['24V','green'],['800 kg','gray'],['ACE','purple']],
      ref: 'SL-ACE801',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_ace_cardin.pdf',
      product: null },

    { id: 'cardin-sl-acefast', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-ACEFAST', subtitle: '24V · Moteur rapide · Portail coulissant',
      tags: [['24V','green'],['Rapide','gray'],['ACE','purple']],
      ref: 'SL-ACEFAST',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_acefast_cardin.pdf',
      product: null },

    { id: 'cardin-sl-evo600', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-EVO600', subtitle: '230V · Max 600kg · Motoréducteur',
      tags: [['230V','green'],['600 kg','gray'],['EVO','purple']],
      ref: 'SL-EVO600',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_evo_cardin.pdf',
      product: null },

    { id: 'cardin-sl-evo800', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-EVO800', subtitle: '230V · Max 800kg · Motoréducteur',
      tags: [['230V','green'],['800 kg','gray'],['EVO','purple']],
      ref: 'SL-EVO800',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_evo_cardin.pdf',
      product: null },

    { id: 'cardin-sl-evo1200', brand: 'cardin', cat: 'moteur_coul', family: 'SL',
      title: 'Cardin SL-EVO1200', subtitle: '230V · Max 1200kg · Motoréducteur',
      tags: [['230V','green'],['1200 kg','gray'],['EVO','purple']],
      ref: 'SL-EVO1200',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sl_evo_cardin.pdf',
      product: null },

    { id: 'cardin-blade', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BLADE', subtitle: '24V / 230V · Vis sans fin · Portail battant',
      tags: [['24V/230V','green'],['Vis sans fin','purple'],['Battant','blue']],
      ref: 'BLADE',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_blade_cardin.pdf',
      product: null },

    { id: 'cardin-bl-stealth', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL STEALTH', subtitle: '24V · Bras · Max 200kg · Compact',
      tags: [['24V','green'],['Bras','purple'],['200 kg','gray']],
      ref: 'BLSTEALTH',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl_stealth_cardin.pdf',
      product: null },

    { id: 'cardin-bltow24', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BLTOW24', subtitle: '24V · Bras articulé · Max 200kg · Encodeur',
      tags: [['24V','green'],['Bras articulé','purple'],['200 kg','gray']],
      ref: 'BLTOW24',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bltow24_cardin.pdf',
      product: null },

    { id: 'cardin-blegos', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BLEGOS / ESOL', subtitle: '24V · Vis sans fin · Max 200kg · Encodeur',
      tags: [['24V','green'],['Vis sans fin','purple'],['200 kg','gray']],
      ref: 'BLEGOS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_blegos_cardin.pdf',
      product: null },

    { id: 'cardin-bl-tag', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL-TAG', subtitle: '24V · Vis sans fin · Autobloquant',
      tags: [['24V','green'],['Vis sans fin','purple'],['Autobloquant','blue']],
      ref: 'BL-TAG',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl_tag_cardin.pdf',
      product: null },

    { id: 'cardin-bl-asy', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL-ASY', subtitle: '24V / 230V · Vis sans fin · Portail battant',
      tags: [['24V/230V','green'],['Vis sans fin','purple'],['Battant','blue']],
      ref: 'BL-ASY',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl_asy_cardin.pdf',
      product: null },

    { id: 'cardin-bl-blues', brand: 'cardin', cat: 'moteur_batt', family: 'BL',
      title: 'Cardin BL-BLUES', subtitle: '230V · Hydraulique · Vis sans fin',
      tags: [['230V','green'],['Hydraulique','purple'],['Vis sans fin','blue']],
      ref: 'BL-BLUES',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bl_blues_cardin.pdf',
      product: null },

    { id: 'cardin-hl-mole', brand: 'cardin', cat: 'moteur_batt', family: 'HL',
      title: 'Cardin HL-MOLE', subtitle: '230V / 24V · Enterré · Électromécanique',
      tags: [['230V/24V','green'],['Enterré','purple'],['Battant','blue']],
      ref: 'HL-MOLE',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_hl_mole_cardin.pdf',
      product: null },

    { id: 'cardin-gl-star', brand: 'cardin', cat: 'moteur_garage', family: 'GL',
      title: 'Cardin GL-STAR', subtitle: '230V · Basculante à contrepoids',
      tags: [['230V','green'],['Basculante','purple'],['Contrepoids','gray']],
      ref: 'GL-STAR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gl_star_cardin.pdf',
      product: null },

    { id: 'cardin-gl-zen', brand: 'cardin', cat: 'moteur_garage', family: 'GL',
      title: 'Cardin GL-ZEN', subtitle: '24V · Porte sectionnelle · Entraînement',
      tags: [['24V','green'],['Sectionnelle','purple'],['Entraînement','gray']],
      ref: 'GL-ZEN',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gl_zen_cardin.pdf',
      product: null },

    { id: 'cardin-glb249', brand: 'cardin', cat: 'moteur_garage', family: 'GL',
      title: 'Cardin GLB249', subtitle: '24V · Basculante · Encodeur',
      tags: [['24V','green'],['Basculante','purple'],['Encodeur','blue']],
      ref: 'GLB249',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_glb249_cardin.pdf',
      product: null },

    { id: 'cardin-ssb-t9k4', brand: 'cardin', cat: 'clavier', family: 'SSB',
      title: 'Cardin SSB-T9K4', subtitle: 'Clavier à code numérique · Radio 433 MHz · S449',
      tags: [['433 MHz','green'],['Radio','purple'],['S449','gray']],
      ref: 'SSB-T9K4',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ssb_t9k4_cardin.pdf',
      product: null },

    { id: 'cardin-ssb500', brand: 'cardin', cat: 'clavier', family: 'SSB',
      title: 'Cardin SSB500', subtitle: 'Clavier à code numérique · Radio 433/868 MHz · S504/S508',
      tags: [['433/868 MHz','green'],['Radio','purple'],['S504/S508','gray']],
      ref: 'SSB500',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ssb500_cardin.pdf',
      product: null },

    { id: 'faac-xt2-868-slh-lr', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT2 868 SLH LR', subtitle: '2 canaux · 868.35 MHz · Rolling code SLH LR',
      tags: [['Rolling code','green'],['2 canaux','gray'],['868 MHz','purple'],['LR','blue']],
      ref: '787009',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt2_868_slh_lr_faac.pdf',
      product: null },

    { id: 'faac-xt4-868-slh-lr', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT4 868 SLH LR', subtitle: '4 canaux · 868.35 MHz · Rolling code SLH LR',
      tags: [['Rolling code','green'],['4 canaux','blue'],['868 MHz','purple'],['LR','blue']],
      ref: '787010',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt4_868_slh_lr_faac.pdf',
      product: null },

    { id: 'faac-dl2-868', brand: 'faac', cat: 'telecommande', family: 'DL',
      title: 'FAAC DL2 868 SLH', subtitle: '2 canaux · 868.35 MHz · Rolling code SLH',
      tags: [['Rolling code','green'],['2 canaux','gray'],['868 MHz','purple']],
      ref: '787476',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dl2_868_faac.pdf',
      product: null },

    { id: 'faac-dl4-868', brand: 'faac', cat: 'telecommande', family: 'DL',
      title: 'FAAC DL4 868 SLH', subtitle: '4 canaux · 868.35 MHz · Rolling code SLH',
      tags: [['Rolling code','green'],['4 canaux','blue'],['868 MHz','purple']],
      ref: 'DL4-868',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dl4_868_faac.pdf',
      product: null },

    { id: 'faac-740', brand: 'faac', cat: 'moteur_coul', family: '740',
      title: 'FAAC 740 / 741', subtitle: '230V · Max 500-900kg · Encodeur · Industriel',
      tags: [['230V','orange'],['900 kg','gray'],['Encodeur','purple']],
      ref: '1097805',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_740_faac.pdf',
      product: null },

    { id: 'faac-844', brand: 'faac', cat: 'moteur_coul', family: '844',
      title: 'FAAC 844 C', subtitle: '230V · Max 1800kg · Usage continu · Industriel',
      tags: [['230V','orange'],['1800 kg','gray'],['Industriel','purple']],
      ref: '109925',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_844_faac.pdf',
      product: null },

    { id: 'faac-746-er', brand: 'faac', cat: 'moteur_coul', family: '746',
      title: 'FAAC 746 ER', subtitle: '230V · Max 600kg · Usage continu',
      tags: [['230V','orange'],['600 kg','gray'],['Continu','green']],
      ref: '109745',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_746_er_faac.pdf',
      product: null },

    { id: 'faac-c850', brand: 'faac', cat: 'moteur_coul', family: 'C850',
      title: 'FAAC C850', subtitle: '230V · Max 1800kg · 850W · IP55',
      tags: [['230V','orange'],['1800 kg','gray'],['IP55','blue']],
      ref: '109819',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_c850_faac.pdf',
      product: null },

    { id: 'faac-400', brand: 'faac', cat: 'moteur_batt', family: '400',
      title: 'FAAC 400 / 422', subtitle: '230V · Hydraulique · Max 7m/vantail',
      tags: [['230V','orange'],['Hydraulique','purple'],['7m','gray']],
      ref: '104201',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_400_faac.pdf',
      product: null },

    { id: 'faac-412', brand: 'faac', cat: 'moteur_batt', family: '412',
      title: 'FAAC 412', subtitle: '230V · Électromécanique · Max 1.8m/vantail',
      tags: [['230V','orange'],['1.8m','gray'],['Autobloquant','blue']],
      ref: '104470',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_412_faac.pdf',
      product: null },

    { id: 'faac-770n', brand: 'faac', cat: 'moteur_batt', family: '770',
      title: 'FAAC 770N', subtitle: '230V · Enterré · IP67 · Max 3.5m/vantail',
      tags: [['230V','orange'],['Enterré','purple'],['IP67','blue']],
      ref: '10675201',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_770n_faac.pdf',
      product: null },

    { id: 'faac-e024', brand: 'faac', cat: 'centrale', family: 'E024',
      title: 'FAAC E024 / E024S', subtitle: 'Centrale battants 24V · Swing gate',
      tags: [['24V','green'],['Battants','blue'],['OMNIDEC','purple']],
      ref: 'E024S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_e024_faac.pdf',
      product: null },

    { id: 'faac-e124', brand: 'faac', cat: 'centrale', family: 'E124',
      title: 'FAAC E124', subtitle: 'Centrale battants 230V · BUS-2EASY',
      tags: [['230V','orange'],['Battants','blue'],['BUS-2EASY','purple']],
      ref: 'E124',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_e124_faac.pdf',
      product: null },

    { id: 'faac-e721', brand: 'faac', cat: 'centrale', family: 'E721',
      title: 'FAAC E721', subtitle: 'Centrale coulissant 24V · C720/C721',
      tags: [['24V','green'],['Coulissant','blue'],['C720/C721','gray']],
      ref: 'E721',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_e721_faac.pdf',
      product: null },

    { id: 'faac-xr2-868', brand: 'faac', cat: 'recepteur', family: 'XR',
      title: 'FAAC XR2 868 C', subtitle: 'Récepteur 868 MHz · 2 canaux · OMNIDEC + SLH',
      tags: [['868 MHz','purple'],['2 canaux','gray'],['OMNIDEC','blue']],
      ref: '787023',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xr2_868_faac.pdf',
      product: null },

    { id: 'faac-xp20d', brand: 'faac', cat: 'photocellule', family: 'XP',
      title: 'FAAC XP20 D', subtitle: 'Infrarouge · 20m portée · IP54',
      tags: [['Infrarouge','orange'],['20m','gray'],['IP54','blue']],
      ref: '785102',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xp20d_faac.pdf',
      product: null },

    { id: 'faac-d600', brand: 'faac', cat: 'moteur_garage', family: 'D600',
      title: 'FAAC D600 / D1000', subtitle: '24V · Courroie · Sectionnelle/Basculante',
      tags: [['24V','green'],['Courroie','gray'],['Sectionnelle','blue']],
      ref: 'D600',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_d600_faac.pdf',
      product: null },

    { id: 'faac-390', brand: 'faac', cat: 'moteur_batt', family: '390',
      title: 'FAAC 390', subtitle: '230V / 24V · Électromécanique · Battant',
      tags: [['230V / 24V','orange'],['Battant','blue'],['Électromécanique','gray']],
      ref: '104570',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_390_faac.pdf',
      product: null },

    { id: 'faac-391', brand: 'faac', cat: 'moteur_batt', family: '391',
      title: 'FAAC 391 / 391E', subtitle: '24V · Bras articulé · Battant',
      tags: [['24V','green'],['Bras articulé','blue'],['Battant','gray']],
      ref: '104576',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_391_faac.pdf',
      product: null },

    { id: 'faac-402', brand: 'faac', cat: 'moteur_batt', family: '402',
      title: 'FAAC 402', subtitle: '230V · Hydraulique · Max 4m/vantail',
      tags: [['230V','orange'],['Hydraulique','purple'],['4m','gray']],
      ref: '104468',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_402_faac.pdf',
      product: null },

    { id: 'faac-413', brand: 'faac', cat: 'moteur_batt', family: '413',
      title: 'FAAC 413', subtitle: '230V / 24V · Électromécanique · Max 1.8m/vantail',
      tags: [['230V / 24V','orange'],['1.8m','gray'],['Électromécanique','blue']],
      ref: '104413',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_413_faac.pdf',
      product: null },

    { id: 'faac-415', brand: 'faac', cat: 'moteur_batt', family: '415',
      title: 'FAAC 415 / 415L', subtitle: '230V / 24V · Électromécanique · Battant long',
      tags: [['230V / 24V','orange'],['Battant','blue'],['Long','gray']],
      ref: '104415',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_415_faac.pdf',
      product: null },

    { id: 'faac-s418', brand: 'faac', cat: 'moteur_batt', family: 'S418',
      title: 'FAAC S418', subtitle: '24V · Électromécanique · Compact',
      tags: [['24V','green'],['Compact','blue'],['Battant','gray']],
      ref: '104301',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s418_faac.pdf',
      product: null },

    { id: 'faac-422', brand: 'faac', cat: 'moteur_batt', family: '422',
      title: 'FAAC 422', subtitle: '230V · Hydraulique · Max 5m/vantail',
      tags: [['230V','orange'],['Hydraulique','purple'],['5m','gray']],
      ref: '104211',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_422_faac.pdf',
      product: null },

    { id: 'faac-s450h', brand: 'faac', cat: 'moteur_batt', family: 'S450H',
      title: 'FAAC S450H', subtitle: '230V · Hydraulique · Usage intensif',
      tags: [['230V','orange'],['Hydraulique','purple'],['Intensif','orange']],
      ref: '104100',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s450h_faac.pdf',
      product: null },

    { id: 'faac-750', brand: 'faac', cat: 'moteur_batt', family: '750',
      title: 'FAAC 750 CP', subtitle: '230V · Enterré · IP67 · Max 3m/vantail',
      tags: [['230V','orange'],['Enterré','purple'],['IP67','blue']],
      ref: '107720',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_750_faac.pdf',
      product: null },

    { id: 'faac-s800h', brand: 'faac', cat: 'moteur_batt', family: 'S800H',
      title: 'FAAC S800H ENC', subtitle: '230V · Enterré · Hydraulique · Usage intensif',
      tags: [['230V','orange'],['Enterré','purple'],['Hydraulique','orange']],
      ref: '108720',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s800h_faac.pdf',
      product: null },

    { id: 'faac-s800', brand: 'faac', cat: 'moteur_batt', family: 'S800',
      title: 'FAAC S800 ENC', subtitle: '230V · Enterré · Hydraulique',
      tags: [['230V','orange'],['Enterré','purple'],['Hydraulique','orange']],
      ref: '108800',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s800_faac.pdf',
      product: null },

    { id: 'faac-s2500i', brand: 'faac', cat: 'moteur_batt', family: 'S2500I',
      title: 'FAAC S2500I', subtitle: '230V · Enterré · Hydraulique · Industriel',
      tags: [['230V','orange'],['Enterré','purple'],['Industriel','purple']],
      ref: '104250',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s2500i_faac.pdf',
      product: null },

    { id: 'faac-c720', brand: 'faac', cat: 'moteur_coul', family: 'C720',
      title: 'FAAC C720 / C721', subtitle: '24V · Max 400-800kg · Encodeur',
      tags: [['24V','green'],['800 kg','gray'],['Encodeur','purple']],
      ref: '109320',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_c720_faac.pdf',
      product: null },

    { id: 'faac-844r', brand: 'faac', cat: 'moteur_coul', family: '844',
      title: 'FAAC 844 E R 3PH', subtitle: '380V · Triphasé · Industriel',
      tags: [['380V','orange'],['Triphasé','purple'],['Industriel','purple']],
      ref: '109896',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_844r_faac.pdf',
      product: null },

    { id: 'faac-c851', brand: 'faac', cat: 'moteur_coul', family: 'C851',
      title: 'FAAC C851', subtitle: '230V · Max 1800kg · Usage continu · IP55',
      tags: [['230V','orange'],['1800 kg','gray'],['IP55','blue']],
      ref: '109903',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_c851_faac.pdf',
      product: null },

    { id: 'faac-c4000i', brand: 'faac', cat: 'moteur_coul', family: 'C4000I',
      title: 'FAAC C4000I', subtitle: '230V · Max 4000kg · Industriel lourd',
      tags: [['230V','orange'],['4000 kg','gray'],['Industriel','purple']],
      ref: '109001',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_c4000i_faac.pdf',
      product: null },

    { id: 'faac-d700hs', brand: 'faac', cat: 'moteur_garage', family: 'D700',
      title: 'FAAC D700 HS', subtitle: '24V · Hi-Speed · Sectionnelle/Basculante',
      tags: [['24V','green'],['Hi-Speed','orange'],['Sectionnelle','blue']],
      ref: '110602',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_d700hs_faac.pdf',
      product: null },

    { id: 'faac-d1000', brand: 'faac', cat: 'moteur_garage', family: 'D1000',
      title: 'FAAC D1000', subtitle: '24V · Courroie · Sectionnelle/Basculante',
      tags: [['24V','green'],['Courroie','gray'],['Sectionnelle','blue']],
      ref: '110601',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_d1000_faac.pdf',
      product: null },

    { id: 'faac-540', brand: 'faac', cat: 'moteur_garage', family: '540',
      title: 'FAAC 540 / 541', subtitle: '230V · Sectionnelle/Industrielle · Usage continu',
      tags: [['230V','orange'],['Sectionnelle','blue'],['Industriel','purple']],
      ref: '109540',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_540_faac.pdf',
      product: null },

    { id: 'faac-541-3ph', brand: 'faac', cat: 'moteur_garage', family: '541',
      title: 'FAAC 541 3PH', subtitle: '380V · Triphasé · Sectionnelle industrielle',
      tags: [['380V','orange'],['Triphasé','purple'],['Industriel','purple']],
      ref: '109550',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_541_3ph_faac.pdf',
      product: null },

    { id: 'faac-550', brand: 'faac', cat: 'moteur_garage', family: '550',
      title: 'FAAC 550', subtitle: '230V · Porte basculante · Résidentiel',
      tags: [['230V','orange'],['Basculante','blue'],['Résidentiel','green']],
      ref: '110549',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_550_faac.pdf',
      product: null },

    { id: 'faac-593', brand: 'faac', cat: 'moteur_garage', family: '593',
      title: 'FAAC 593', subtitle: '230V · Porte basculante · Résidentiel',
      tags: [['230V','orange'],['Basculante','blue'],['Résidentiel','green']],
      ref: '110597',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_593_faac.pdf',
      product: null },

    { id: 'faac-e045s', brand: 'faac', cat: 'centrale', family: 'E045S',
      title: 'FAAC E045S', subtitle: 'Centrale 24V · Portails battants/coulissants',
      tags: [['24V','green'],['Multifonctions','blue'],['Nouvelle gen.','green']],
      ref: '790077',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_e045s_faac.pdf',
      product: null },

    { id: 'faac-e145s', brand: 'faac', cat: 'centrale', family: 'E145S',
      title: 'FAAC E145S', subtitle: 'Centrale 230V · Portails battants/coulissants',
      tags: [['230V','orange'],['Multifonctions','blue'],['Nouvelle gen.','green']],
      ref: '790076',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_e145s_faac.pdf',
      product: null },

    { id: 'faac-455d', brand: 'faac', cat: 'centrale', family: '455D',
      title: 'FAAC 455D', subtitle: 'Centrale 230V · Portails battants',
      tags: [['230V','orange'],['Battants','blue']],
      ref: '790917',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_455d_faac.pdf',
      product: null },

    { id: 'faac-740d', brand: 'faac', cat: 'centrale', family: '740D',
      title: 'FAAC 740D', subtitle: 'Centrale 230V · Portails coulissants 740/741',
      tags: [['230V','orange'],['Coulissant','blue'],['740/741','gray']],
      ref: '202269',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_740d_faac.pdf',
      product: null },

    { id: 'faac-578d', brand: 'faac', cat: 'centrale', family: '578D',
      title: 'FAAC 578D', subtitle: 'Centrale 230V · Portails coulissants',
      tags: [['230V','orange'],['Coulissant','blue']],
      ref: '790922',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_578d_faac.pdf',
      product: null },

    { id: 'faac-540bpr', brand: 'faac', cat: 'centrale', family: '540BPR',
      title: 'FAAC 540BPR', subtitle: 'Centrale 230V · Portes sectionnelles',
      tags: [['230V','orange'],['Sectionnelle','blue']],
      ref: '540BPR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_540bpr_faac.pdf',
      product: null },

    { id: 'faac-624bld', brand: 'faac', cat: 'centrale', family: '624BLD',
      title: 'FAAC 624BLD', subtitle: 'Centrale 24V · Barrières automatiques',
      tags: [['24V','green'],['Barrières','blue']],
      ref: '624BLD',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_624bld_faac.pdf',
      product: null },

    { id: 'faac-e034', brand: 'faac', cat: 'centrale', family: 'E034',
      title: 'FAAC E034', subtitle: 'Centrale 24V · Battants · Nouvelle génération',
      tags: [['24V','green'],['Battants','blue'],['Nouvelle gen.','green']],
      ref: 'E034',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_e034_faac.pdf',
      product: null },

    { id: 'faac-xr4-868', brand: 'faac', cat: 'recepteur', family: 'XR',
      title: 'FAAC XR4 868 C', subtitle: 'Récepteur 868 MHz · 4 canaux · OMNIDEC + SLH',
      tags: [['868 MHz','purple'],['4 canaux','blue'],['OMNIDEC','blue']],
      ref: '787024',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xr4_868_faac.pdf',
      product: null },

    { id: 'faac-rp2-868', brand: 'faac', cat: 'recepteur', family: 'RP',
      title: 'FAAC RP2 868 SLH', subtitle: 'Récepteur 868 MHz · 2 canaux · Embrochable',
      tags: [['868 MHz','purple'],['2 canaux','gray'],['Embrochable','green']],
      ref: 'RP2-868',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rp2_868_faac.pdf',
      product: null },

    { id: 'faac-xt2-xt4-fds', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT2 / XT4 FDS', subtitle: '2-4 canaux · Code fixe · OMNIDEC',
      tags: [['Code fixe','orange'],['OMNIDEC','blue'],['FDS','gray']],
      ref: 'XT FDS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt2_xt4_fds_faac.pdf',
      product: null },

    { id: 'faac-xt4-433-rc', brand: 'faac', cat: 'telecommande', family: 'XT',
      title: 'FAAC XT4 433 RC', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433 MHz','gray']],
      ref: 'XT4-433-RC',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xt4_433_rc_faac.pdf',
      product: null },

    { id: 'faac-xp30', brand: 'faac', cat: 'photocellule', family: 'XP',
      title: 'FAAC XP30 D', subtitle: 'Infrarouge · 30m portée · IP54',
      tags: [['Infrarouge','orange'],['30m','gray'],['IP54','blue']],
      ref: 'XP30',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xp30_faac.pdf',
      product: null },

    { id: 'faac-xkp', brand: 'faac', cat: 'clavier', family: 'XKP',
      title: 'FAAC XKP B', subtitle: 'Clavier à code · Rétroéclairé · IP54',
      tags: [['Clavier','blue'],['Rétroéclairé','green'],['IP54','gray']],
      ref: 'XKP-B',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xkp_faac.pdf',
      product: null },

    { id: 'faac-xk30', brand: 'faac', cat: 'clavier', family: 'XK30',
      title: 'FAAC XK30', subtitle: 'Clavier à code · Encastrable',
      tags: [['Clavier','blue'],['Encastrable','purple']],
      ref: 'XK30',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xk30_faac.pdf',
      product: null },

    { id: 'faac-xled', brand: 'faac', cat: 'clignotant', family: 'XLED',
      title: 'FAAC XLED', subtitle: 'Clignotant LED · 24V · Antenne intégrée',
      tags: [['LED','green'],['24V','orange'],['Antenne intégrée','blue']],
      ref: '410029',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_xled_faac.pdf',
      product: null },

    { id: 'bft-kleio-rca02', brand: 'bft', cat: 'telecommande', family: 'Kleio',
      title: 'BFT Kleio B RCA02', subtitle: '2 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['2 canaux','gray'],['433.92 MHz','gray']],
      ref: 'D111905',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_kleio_rca02_bft.pdf',
      product: null },

    { id: 'bft-kleio-rca04', brand: 'bft', cat: 'telecommande', family: 'Kleio',
      title: 'BFT Kleio B RCA04', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['4 canaux','blue'],['433.92 MHz','gray']],
      ref: 'D111906',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_kleio_rca04_bft.pdf',
      product: null },

    { id: 'bft-deimos-bt', brand: 'bft', cat: 'moteur_coul', family: 'DEIMOS',
      title: 'BFT DEIMOS BT A400 / A600', subtitle: '24V · Max 400-600kg · Centrale intégrée',
      tags: [['24V','green'],['600 kg','gray'],['Centrale intégrée','purple']],
      ref: 'DEIMOS-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_deimos_bt_bft.pdf',
      product: null },

    { id: 'bft-ares-bt', brand: 'bft', cat: 'moteur_coul', family: 'ARES',
      title: 'BFT ARES BT A1000 / A1500', subtitle: '24V · Max 1000-1500kg · Crémaillère',
      tags: [['24V','green'],['1500 kg','gray'],['Crémaillère','blue']],
      ref: 'ARES-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ares_bt_bft.pdf',
      product: null },

    { id: 'bft-icaro-ac', brand: 'bft', cat: 'moteur_coul', family: 'ICARO',
      title: 'BFT ICARO AC A2000', subtitle: '230V · Max 2000kg · Industriel',
      tags: [['230V','orange'],['2000 kg','gray'],['Industriel','purple']],
      ref: 'ICARO-AC',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_icaro_ac_bft.pdf',
      product: null },

    { id: 'bft-phobos-bt', brand: 'bft', cat: 'moteur_batt', family: 'PHOBOS',
      title: 'BFT PHOBOS BT A25 / A40', subtitle: '24V · Max 250-400kg · Bras articulé',
      tags: [['24V','green'],['400 kg','gray'],['Bras articulé','blue']],
      ref: 'PHOBOS-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_phobos_bt_bft.pdf',
      product: null },

    { id: 'bft-virgo-bt', brand: 'bft', cat: 'moteur_batt', family: 'VIRGO',
      title: 'BFT VIRGO SMART BT A20', subtitle: '24V · Max 200kg · Bras articulé',
      tags: [['24V','green'],['200 kg','gray'],['Bras articulé','blue']],
      ref: 'VIRGO-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_virgo_bt_bft.pdf',
      product: null },

    { id: 'bft-lux-bt', brand: 'bft', cat: 'moteur_batt', family: 'LUX',
      title: 'BFT LUX BT 2B', subtitle: '24V · Enterré · Hydraulique',
      tags: [['24V','green'],['Enterré','purple'],['Hydraulique','orange']],
      ref: 'LUX-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_lux_bt_bft.pdf',
      product: null },

    { id: 'bft-thalia', brand: 'bft', cat: 'centrale', family: 'THALIA',
      title: 'BFT THALIA', subtitle: 'Centrale 24V · D-Track · Autoapprentissage',
      tags: [['24V','green'],['D-Track','blue'],['Autoapprentissage','purple']],
      ref: 'D811762',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_thalia_bft.pdf',
      product: null },

    { id: 'bft-thalia-p', brand: 'bft', cat: 'centrale', family: 'THALIA',
      title: 'BFT THALIA P', subtitle: 'Centrale 24V · Programmable · Écran',
      tags: [['24V','green'],['Programmable','blue'],['Écran','purple']],
      ref: 'D811780',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_thalia_p_bft.pdf',
      product: null },

    { id: 'bft-rigel5', brand: 'bft', cat: 'centrale', family: 'RIGEL',
      title: 'BFT RIGEL 5 / 6', subtitle: 'Centrale 230V · Écran · Récepteur intégré',
      tags: [['230V','orange'],['Écran','purple'],['Récepteur intégré','green']],
      ref: 'RIGEL-5',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rigel5_bft.pdf',
      product: null },

    { id: 'bft-clonix-2e', brand: 'bft', cat: 'recepteur', family: 'CLONIX',
      title: 'BFT CLONIX 2E', subtitle: 'Récepteur 433.92 MHz · 2 canaux · 128 codes',
      tags: [['433.92 MHz','gray'],['2 canaux','blue'],['Rolling code','green']],
      ref: 'CLONIX-2E',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_clonix_2e_bft.pdf',
      product: null },

    { id: 'bft-botticelli-bt', brand: 'bft', cat: 'moteur_garage', family: 'BOTTICELLI',
      title: 'BFT BOTTICELLI BT A650 / A850 / A1250', subtitle: '24V · Sectionnelle · Courroie',
      tags: [['24V','green'],['Sectionnelle','blue'],['Courroie','gray']],
      ref: 'BOTTICELLI-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_botticelli_bt_bft.pdf',
      product: null },

    { id: 'bft-deimos-ultra-bt', brand: 'bft', cat: 'moteur_coul', family: 'DEIMOS',
      title: 'BFT DEIMOS ULTRA BT', subtitle: '24V · Coulissant 400-600kg · Fin de course magnétique',
      tags: [['24V','green'],['600 kg','gray'],['Ultra','blue']],
      ref: 'DEIMOS-ULTRA-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_deimos_ultra_bt_bft.pdf',
      product: null },

    { id: 'bft-ares-ultra-bt', brand: 'bft', cat: 'moteur_coul', family: 'ARES',
      title: 'BFT ARES ULTRA BT', subtitle: '24V · Coulissant 1000-1500kg · Usage intensif',
      tags: [['24V','green'],['1500 kg','gray'],['Ultra','blue']],
      ref: 'ARES-ULTRA-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ares_ultra_bt_bft.pdf',
      product: null },

    { id: 'bft-kustos-bt', brand: 'bft', cat: 'moteur_batt', family: 'KUSTOS',
      title: 'BFT KUSTOS BT A25 / A40', subtitle: '24V · Bras articulé · 400-500kg',
      tags: [['24V','green'],['Bras articulé','blue'],['500 kg','gray']],
      ref: 'KUSTOS-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_kustos_bt_bft.pdf',
      product: null },

    { id: 'bft-eli-bt', brand: 'bft', cat: 'moteur_batt', family: 'ELI',
      title: 'BFT ELI BT A35V / A40', subtitle: '24V · Enterré · 250-350 Nm',
      tags: [['24V','green'],['Enterré','purple'],['350 Nm','gray']],
      ref: 'ELI-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_eli_bt_bft.pdf',
      product: null },

    { id: 'bft-phebe-bt', brand: 'bft', cat: 'moteur_garage', family: 'PHEBE',
      title: 'BFT PHEBE BT', subtitle: '24V · Porte basculante · Résidentiel',
      tags: [['24V','green'],['Basculante','blue'],['Résidentiel','gray']],
      ref: 'PHEBE-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_phebe_bt_bft.pdf',
      product: null },

    { id: 'bft-tiziano', brand: 'bft', cat: 'moteur_garage', family: 'TIZIANO',
      title: 'BFT TIZIANO GDA 260', subtitle: 'Ultra-compact 13cm · Sectionnelle · Récepteur intégré',
      tags: [['Compact','green'],['Sectionnelle','blue'],['Radio intégrée','purple']],
      ref: 'TIZIANO-GDA260',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_tiziano_bft.pdf',
      product: null },

    { id: 'bft-clonix-4-rte', brand: 'bft', cat: 'recepteur', family: 'CLONIX',
      title: 'BFT CLONIX 4 RTE', subtitle: '4 canaux · 433 MHz · 12/24V · 2048 codes',
      tags: [['4 canaux','blue'],['433 MHz','gray'],['2048 codes','green']],
      ref: 'CLONIX-4-RTE',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_clonix_4_rte_bft.pdf',
      product: null },

    { id: 'bft-qbo-touch', brand: 'bft', cat: 'clavier', family: 'Q.BO',
      title: 'BFT Q.BO TOUCH', subtitle: 'Digicode sans fil · 433 MHz · 10 canaux · 100 codes',
      tags: [['Sans fil','green'],['433 MHz','gray'],['100 codes','blue']],
      ref: 'QBO-TOUCH',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_qbo_touch_bft.pdf',
      product: null },

    { id: 'bft-desme-a15', brand: 'bft', cat: 'photocellule', family: 'DESME',
      title: 'BFT DESME A15', subtitle: 'Photocellules · Portée 30m · 24V · Auto-alignement',
      tags: [['24V','green'],['30 m','gray'],['Auto-alignement','blue']],
      ref: 'DESME-A15',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_desme_a15_bft.pdf',
      product: null },

    { id: 'bft-radius-led-bt', brand: 'bft', cat: 'clignotant', family: 'RADIUS',
      title: 'BFT RADIUS LED BT', subtitle: 'Clignotant LED · 24V · Antenne intégrée · IP44',
      tags: [['LED','green'],['24V','orange'],['Antenne intégrée','blue']],
      ref: 'RADIUS-LED-BT',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_radius_led_bt_bft.pdf',
      product: null },

    { id: 'somfy-freevia-280-300', brand: 'somfy', cat: 'moteur_coul', family: 'Freevia',
      title: 'Somfy Freevia 280 / 300', subtitle: '230V · Max 280-300kg · RTS',
      tags: [['230V','orange'],['300 kg','gray'],['RTS','green']],
      ref: 'Freevia 280/300',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_freevia_280_300_somfy.pdf',
      product: null },

    { id: 'somfy-freevia-400', brand: 'somfy', cat: 'moteur_coul', family: 'Freevia',
      title: 'Somfy Freevia 400', subtitle: '24V · Max 400kg · RTS',
      tags: [['24V','green'],['400 kg','gray'],['RTS','green']],
      ref: '5129045A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_freevia_400_somfy.pdf',
      product: null },

    { id: 'somfy-slidymoove-300', brand: 'somfy', cat: 'moteur_coul', family: 'Slidymoove',
      title: 'Somfy Slidymoove 300', subtitle: '24V · Max 300kg · RTS',
      tags: [['24V','green'],['300 kg','gray'],['RTS','green']],
      ref: 'Slidymoove 300',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slidymoove_300_somfy.pdf',
      product: null },

    { id: 'somfy-slidymoove-600', brand: 'somfy', cat: 'moteur_coul', family: 'Slidymoove',
      title: 'Somfy Slidymoove 600', subtitle: '24V · Max 600kg · RTS',
      tags: [['24V','green'],['600 kg','gray'],['RTS','green']],
      ref: '5138230B',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_slidymoove_600_somfy.pdf',
      product: null },

    { id: 'somfy-elixo-500-3s', brand: 'somfy', cat: 'moteur_coul', family: 'Elixo',
      title: 'Somfy Elixo 500 3S io', subtitle: '230V · Max 500kg · io-homecontrol · Pro',
      tags: [['230V','orange'],['500 kg','gray'],['io','purple'],['Pro','blue']],
      ref: '5073265C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_elixo_500_3s_somfy.pdf',
      product: null },

    { id: 'somfy-elixo-smart', brand: 'somfy', cat: 'moteur_coul', family: 'Elixo',
      title: 'Somfy Elixo Smart io', subtitle: 'Connecté · io-homecontrol',
      tags: [['io','purple'],['Connecté','green'],['Smart','blue']],
      ref: 'Elixo Smart',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_elixo_smart_somfy.pdf',
      product: null },

    { id: 'somfy-freevia-290', brand: 'somfy', cat: 'moteur_coul', family: 'Freevia',
      title: 'Somfy Freevia 290', subtitle: '230V · Max 290kg · RTS',
      tags: [['230V','orange'],['290 kg','gray'],['RTS','green']],
      ref: 'Freevia 290',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_freevia_290_somfy.pdf',
      product: null },

    { id: 'somfy-freevia-390', brand: 'somfy', cat: 'moteur_coul', family: 'Freevia',
      title: 'Somfy Freevia 390', subtitle: '24V · Max 390kg · io-homecontrol',
      tags: [['24V','green'],['390 kg','gray'],['io','purple']],
      ref: 'Freevia 390',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_freevia_390_somfy.pdf',
      product: null },

    { id: 'somfy-ls420', brand: 'somfy', cat: 'moteur_coul', family: 'LS',
      title: 'Somfy LS 420', subtitle: '230V · Coulissant · RTS',
      tags: [['230V','orange'],['RTS','green']],
      ref: 'LS 420',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ls420_somfy.pdf',
      product: null },

    { id: 'somfy-ls430', brand: 'somfy', cat: 'moteur_coul', family: 'LS',
      title: 'Somfy LS 430', subtitle: '230V · Coulissant · RTS',
      tags: [['230V','orange'],['RTS','green']],
      ref: 'LS 430',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ls430_somfy.pdf',
      product: null },

    { id: 'somfy-ls440', brand: 'somfy', cat: 'moteur_coul', family: 'LS',
      title: 'Somfy LS 440', subtitle: '24V · Coulissant · io-homecontrol',
      tags: [['24V','green'],['io','purple']],
      ref: 'LS 440',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ls440_somfy.pdf',
      product: null },

    { id: 'somfy-ls650', brand: 'somfy', cat: 'moteur_coul', family: 'LS',
      title: 'Somfy LS 650', subtitle: '24V · Coulissant · io-homecontrol',
      tags: [['24V','green'],['io','purple']],
      ref: 'LS 650',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ls650_somfy.pdf',
      product: null },

    { id: 'somfy-sld-3000', brand: 'somfy', cat: 'moteur_coul', family: 'SLD',
      title: 'Somfy SLD 3000', subtitle: '230V · Coulissant · RTS',
      tags: [['230V','orange'],['RTS','green']],
      ref: 'SLD 3000',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sld_3000_somfy.pdf',
      product: null },

    { id: 'somfy-ls400', brand: 'somfy', cat: 'moteur_coul', family: 'LS',
      title: 'Somfy LS 400', subtitle: '230V · Coulissant',
      tags: [['230V','orange']],
      ref: 'LS 400',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ls400_somfy.pdf',
      product: null },

    { id: 'somfy-elixo-500-rts-24v', brand: 'somfy', cat: 'moteur_coul', family: 'Elixo',
      title: 'Somfy Elixo 500 RTS 24V', subtitle: '24V · Max 500kg · RTS',
      tags: [['24V','green'],['500 kg','gray'],['RTS','green']],
      ref: 'Elixo 500 RTS 24V',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_elixo_500_rts_24v_somfy.pdf',
      product: null },

    { id: 'somfy-elixo-500-rts-230v', brand: 'somfy', cat: 'moteur_coul', family: 'Elixo',
      title: 'Somfy Elixo 500 RTS 230V', subtitle: '230V · Max 500kg · RTS',
      tags: [['230V','orange'],['500 kg','gray'],['RTS','green']],
      ref: 'Elixo 500 RTS 230V',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_elixo_500_rts_230v_somfy.pdf',
      product: null },

    { id: 'somfy-elixo-500-3s-rts', brand: 'somfy', cat: 'moteur_coul', family: 'Elixo',
      title: 'Somfy Elixo 500 3S RTS', subtitle: '24V · Max 500kg · RTS · 3S',
      tags: [['24V','green'],['500 kg','gray'],['RTS','green'],['3S','blue']],
      ref: 'Elixo 500 3S RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_elixo_500_3s_rts_somfy.pdf',
      product: null },

    { id: 'somfy-elixo-optimo', brand: 'somfy', cat: 'moteur_coul', family: 'Elixo',
      title: 'Somfy Elixo Optimo RTS', subtitle: '230V · Coulissant · RTS',
      tags: [['230V','orange'],['RTS','green']],
      ref: 'Elixo Optimo',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_elixo_optimo_somfy.pdf',
      product: null },

    { id: 'somfy-go-slg7', brand: 'somfy', cat: 'moteur_coul', family: 'GO',
      title: 'Somfy GO SLG 7', subtitle: '230V · Coulissant',
      tags: [['230V','orange']],
      ref: 'GO SLG 7',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_go_slg7_somfy.pdf',
      product: null },

    { id: 'somfy-ixengo-l-3s', brand: 'somfy', cat: 'moteur_batt', family: 'Ixengo',
      title: 'Somfy Ixengo L 3S io', subtitle: '24V · Max 400kg · io-homecontrol · Pro',
      tags: [['24V','green'],['400 kg','gray'],['io','purple'],['Pro','blue']],
      ref: 'Ixengo L 3S',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ixengo_l_3s_somfy.pdf',
      product: null },

    { id: 'somfy-evolvia-400', brand: 'somfy', cat: 'moteur_batt', family: 'Evolvia',
      title: 'Somfy Evolvia 400 / 450', subtitle: '24V · Bras articulé · RTS',
      tags: [['24V','green'],['Bras articulé','blue'],['RTS','green']],
      ref: '5063223D',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_evolvia_400_somfy.pdf',
      product: null },

    { id: 'somfy-exavia-500', brand: 'somfy', cat: 'moteur_batt', family: 'Exavia',
      title: 'Somfy Exavia 500', subtitle: '24V · Bras articulé · RTS',
      tags: [['24V','green'],['Bras articulé','blue'],['RTS','green']],
      ref: '5073814C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_exavia_500_somfy.pdf',
      product: null },

    { id: 'somfy-axovia-220b', brand: 'somfy', cat: 'moteur_batt', family: 'Axovia',
      title: 'Somfy Axovia 220B RTS', subtitle: '230V · Bras articulé · RTS',
      tags: [['230V','orange'],['Bras articulé','blue'],['RTS','green']],
      ref: '5136948A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_axovia_220b_somfy.pdf',
      product: null },

    { id: 'somfy-axovia-multipro', brand: 'somfy', cat: 'moteur_batt', family: 'Axovia',
      title: 'Somfy Axovia Multipro 3S io', subtitle: 'Bras articulé · io-homecontrol · Pro',
      tags: [['io','purple'],['Bras articulé','blue'],['Pro','blue']],
      ref: '5136471A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_axovia_multipro_somfy.pdf',
      product: null },

    { id: 'somfy-sgs-201', brand: 'somfy', cat: 'moteur_batt', family: 'SGS',
      title: 'Somfy SGS 201', subtitle: '24V · Enterré · RTS',
      tags: [['24V','green'],['Enterré','purple'],['RTS','green']],
      ref: '5134661B',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sgs_201_somfy.pdf',
      product: null },

    { id: 'somfy-sgs-501', brand: 'somfy', cat: 'moteur_batt', family: 'SGS',
      title: 'Somfy SGS 501', subtitle: '230V · Enterré · RTS',
      tags: [['230V','orange'],['Enterré','purple'],['RTS','green']],
      ref: '5073896C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sgs_501_somfy.pdf',
      product: null },

    { id: 'somfy-sga-4100', brand: 'somfy', cat: 'moteur_batt', family: 'SGA',
      title: 'Somfy SGA 4100', subtitle: '24V · Bras articulé · RTS',
      tags: [['24V','green'],['Bras articulé','blue'],['RTS','green']],
      ref: '5053118C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sga_4100_somfy.pdf',
      product: null },

    { id: 'somfy-sga-6000', brand: 'somfy', cat: 'moteur_batt', family: 'SGA',
      title: 'Somfy SGA 6000', subtitle: '24V · Bras articulé · Max 600kg · RTS',
      tags: [['24V','green'],['600 kg','gray'],['RTS','green']],
      ref: '5133269B',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_sga_6000_somfy.pdf',
      product: null },

    { id: 'somfy-dexxo-pro-3s', brand: 'somfy', cat: 'moteur_garage', family: 'Dexxo',
      title: 'Somfy Dexxo Pro 3S io', subtitle: 'io-homecontrol · Sectionnelle/Basculante',
      tags: [['io','purple'],['Sectionnelle','blue'],['Pro','blue']],
      ref: '5117832B',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dexxo_pro_3s_somfy.pdf',
      product: null },

    { id: 'somfy-dexxo-compact', brand: 'somfy', cat: 'moteur_garage', family: 'Dexxo',
      title: 'Somfy Dexxo Compact RTS', subtitle: 'RTS · Sectionnelle/Basculante',
      tags: [['RTS','green'],['Sectionnelle','blue'],['Compact','gray']],
      ref: '5072364E',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dexxo_compact_somfy.pdf',
      product: null },

    { id: 'somfy-dexxo-optimo', brand: 'somfy', cat: 'moteur_garage', family: 'Dexxo',
      title: 'Somfy Dexxo Optimo RTS', subtitle: 'RTS · Sectionnelle/Basculante',
      tags: [['RTS','green'],['Sectionnelle','blue'],['Optimo','gray']],
      ref: '5056735D',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dexxo_optimo_somfy.pdf',
      product: null },

    { id: 'somfy-dexxo-smart', brand: 'somfy', cat: 'moteur_garage', family: 'Dexxo',
      title: 'Somfy Dexxo Smart io', subtitle: 'Connecté · io-homecontrol',
      tags: [['io','purple'],['Connecté','green'],['Smart','blue']],
      ref: '5143221A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_dexxo_smart_somfy.pdf',
      product: null },

    { id: 'somfy-gdk-700', brand: 'somfy', cat: 'moteur_garage', family: 'GDK',
      title: 'Somfy GDK 700', subtitle: 'Chaîne · RTS · Sectionnelle/Basculante',
      tags: [['RTS','green'],['Chaîne','gray'],['Sectionnelle','blue']],
      ref: '5130194B',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gdk_700_somfy.pdf',
      product: null },

    { id: 'somfy-gdk-3000-4000', brand: 'somfy', cat: 'moteur_garage', family: 'GDK',
      title: 'Somfy GDK 3000 / 4000', subtitle: 'Courroie · RTS · Sectionnelle/Basculante',
      tags: [['RTS','green'],['Courroie','gray'],['Sectionnelle','blue']],
      ref: 'GDK 3000/4000',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_gdk_3000_4000_somfy.pdf',
      product: null },

    { id: 'somfy-situo-rts', brand: 'somfy', cat: 'telecommande', family: 'Situo',
      title: 'Somfy Situo 1 / 5 RTS', subtitle: '1 ou 5 canaux · 433.42 MHz · RTS',
      tags: [['RTS','green'],['5 canaux','blue'],['433.42 MHz','gray']],
      ref: 'Situo RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_situo_rts_somfy.pdf',
      product: null },

    { id: 'somfy-nina-timer', brand: 'somfy', cat: 'telecommande', family: 'Nina',
      title: 'Somfy Nina Timer io', subtitle: 'Tactile programmable · io-homecontrol',
      tags: [['io','purple'],['Tactile','blue'],['Programmable','green']],
      ref: '5129413C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_nina_timer_somfy.pdf',
      product: null },

    { id: 'somfy-digipad-rts', brand: 'somfy', cat: 'clavier', family: 'Digipad',
      title: 'Somfy Digipad RTS', subtitle: 'Sans fil · 433.42 MHz · RTS · IP54',
      tags: [['RTS','green'],['Sans fil','blue'],['IP54','gray']],
      ref: 'Digipad RTS',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_digipad_rts_somfy.pdf',
      product: null },

    { id: 'somfy-keypad-metal', brand: 'somfy', cat: 'clavier', family: 'Keypad',
      title: 'Somfy Keypad Metal io', subtitle: 'Métal · Sans fil · io-homecontrol',
      tags: [['io','purple'],['Métal','gray'],['Sans fil','blue']],
      ref: '5115206C',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_keypad_metal_somfy.pdf',
      product: null },

    { id: 'somfy-cbx-3s-io', brand: 'somfy', cat: 'centrale', family: 'CBx',
      title: 'Somfy CBx 3S io', subtitle: 'Centrale portail · io-homecontrol',
      tags: [['io','purple'],['Portail','blue'],['Pro','blue']],
      ref: 'CBx 3S io',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_cbx_3s_io_somfy.pdf',
      product: null },

    { id: 'nice-era-p', brand: 'nice', cat: 'telecommande', family: 'Era',
      title: 'Nice Era P', subtitle: 'Radio · 433.92 MHz · O-Code · NiceOpera',
      tags: [['O-Code','green'],['NiceOpera','purple'],['433.92 MHz','gray']],
      ref: 'IS0104A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_era_p_nice.pdf',
      product: null },

    { id: 'nice-mc800', brand: 'nice', cat: 'centrale', family: 'MC',
      title: 'Nice MC800', subtitle: 'Centrale coulissants · BlueBUS · BusT4',
      tags: [['Coulissant','blue'],['BlueBUS','blue'],['BusT4','purple']],
      ref: 'IDV0544A00FR',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_mc800_nice.pdf',
      product: null },

    { id: 'nice-a924', brand: 'nice', cat: 'centrale', family: 'Mindy',
      title: 'Nice Mindy A924', subtitle: 'Centrale battants · 230V',
      tags: [['230V','orange'],['Battants','blue']],
      ref: 'ISTA924.4858',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_a924_nice.pdf',
      product: null },

    { id: 'nice-tt1n', brand: 'nice', cat: 'clavier', family: 'TT',
      title: 'Nice TT1N', subtitle: 'Clavier à code · Radio · Rolling code',
      tags: [['Radio','purple'],['Rolling code','green']],
      ref: 'IST158R01.4858',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_tt1n_nice.pdf',
      product: null },

    { id: 'nice-tt2n', brand: 'nice', cat: 'clavier', family: 'TT',
      title: 'Nice TT2N', subtitle: 'Clavier à code · Radio · Rétroéclairé',
      tags: [['Radio','purple'],['Rolling code','green'],['Rétroéclairé','blue']],
      ref: 'IST205R03.4858',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_tt2n_nice.pdf',
      product: null },

    { id: 'nice-epmor', brand: 'nice', cat: 'photocellule', family: 'EPM',
      title: 'Nice EPMOR / EPMOW', subtitle: 'Era · Orientation réglable · BlueBUS',
      tags: [['BlueBUS','blue'],['Orientable','blue'],['Era','green']],
      ref: 'IS0527A01MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_epmor_nice.pdf',
      product: null },

    { id: 'nice-oxi-a', brand: 'nice', cat: 'recepteur', family: 'OXI',
      title: 'Nice OXI/A', subtitle: 'Récepteur NiceOne · 433.92 MHz · O-Code',
      tags: [['O-Code','green'],['433.92 MHz','gray'],['NiceOne','purple']],
      ref: 'IS0242A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_oxi_a_nice.pdf',
      product: null },

    { id: 'nice-flor', brand: 'nice', cat: 'recepteur', family: 'FLOR',
      title: 'Nice FLOR', subtitle: 'Récepteur universel · 433.92 MHz · FLO/SMILO',
      tags: [['433.92 MHz','gray'],['Universel','green'],['FLO/SMILO','purple']],
      ref: 'IS0063A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_flor_nice.pdf',
      product: null },

    { id: 'nice-ox4', brand: 'nice', cat: 'recepteur', family: 'OX',
      title: 'Nice OX4 / OX4T', subtitle: 'Récepteur 4 canaux · 433.92 MHz · O-Code/FLO-R',
      tags: [['4 canaux','blue'],['433.92 MHz','gray'],['O-Code','green']],
      ref: 'IST236R02',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ox4_nice.pdf',
      product: null },

    { id: 'nice-ft210b', brand: 'nice', cat: 'photocellule', family: 'FT',
      title: 'Nice FT210B', subtitle: 'Photocellule · Portée 30m · BlueBUS',
      tags: [['BlueBUS','blue'],['30m','gray'],['Orientable','purple']],
      ref: 'IST200R01',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ft210b_nice.pdf',
      product: null },

    { id: 'nice-era-el', brand: 'nice', cat: 'clignotant', family: 'ERA',
      title: 'Nice ERA EL', subtitle: 'Clignotant LED · 12-36V · BlueBUS',
      tags: [['LED','green'],['BlueBUS','blue'],['12-36V','gray']],
      ref: 'IS0392A00MM',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_era_el_nice.pdf',
      product: null },

    { id: 'nice-eds', brand: 'nice', cat: 'clavier', family: 'EDS',
      title: 'Nice EDS / EDSI / ETP', subtitle: 'Clavier à code · Sélecteur · BlueBUS',
      tags: [['BlueBUS','blue'],['Code','purple'],['Rétroéclairé','gray']],
      ref: 'IS0294A02MMD',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_eds_nice.pdf',
      product: null },

    { id: 'came-zl19n', brand: 'came', cat: 'centrale', family: 'ZL',
      title: 'CAME ZL19N', subtitle: 'Centrale 24V · FERNI/FROG',
      tags: [['24V','green'],['Battants','blue'],['Multifonctions','green']],
      ref: '319U33',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_zl19n_came.pdf',
      product: null },

    { id: 'came-zl92', brand: 'came', cat: 'centrale', family: 'ZL',
      title: 'CAME ZL92', subtitle: 'Centrale 24V · STYLO/MYTO/FROG-J',
      tags: [['24V','green'],['Battants','blue'],['Multifonctions','green']],
      ref: '319V21',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_zl92_came.pdf',
      product: null },

    { id: 'came-axi', brand: 'came', cat: 'moteur_batt', family: 'AXI',
      title: 'CAME AXI', subtitle: 'Irréversible · Encodeur · Battant',
      tags: [['Irréversible','orange'],['Encodeur','purple'],['Battant','blue']],
      ref: 'FA01081M04',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_axi_came.pdf',
      product: null },

    { id: 'came-delta', brand: 'came', cat: 'photocellule', family: 'Delta',
      title: 'CAME Delta-E / Delta-I', subtitle: 'Encastrable · Infrarouge · 12/24V',
      tags: [['Infrarouge','orange'],['Encastrable','purple'],['12/24V','green']],
      ref: 'FA01071M4A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_delta_came.pdf',
      product: null },

    { id: 'came-s6000', brand: 'came', cat: 'clavier', family: 'S6000',
      title: 'CAME S6000 / S7000', subtitle: 'Clavier à code digital · Contrôle d\'accès',
      tags: [['Digital','blue'],['Contrôle accès','green']],
      ref: 'FA00649M4A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_s6000_came.pdf',
      product: null },

    { id: 'came-top862ev', brand: 'came', cat: 'telecommande', family: 'TOP',
      title: 'CAME TOP-862EV / TOP-864EV', subtitle: '2-4 canaux · 868.35 MHz · Rolling code',
      tags: [['Rolling code','green'],['868 MHz','purple'],['4 canaux','blue']],
      ref: 'FA01085M04',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_top862ev_came.pdf',
      product: null },

    { id: 'came-ttsd4rks', brand: 'came', cat: 'telecommande', family: 'TTS',
      title: 'CAME TTSD4RKS', subtitle: '4 canaux · 433.92/868.35 MHz · Rolling code',
      tags: [['Rolling code','green'],['Bi-fréquence','purple'],['4 canaux','blue']],
      ref: 'FA02091M4A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_ttsd4rks_came.pdf',
      product: null },

    { id: 'came-tts44rks', brand: 'came', cat: 'telecommande', family: 'TTS',
      title: 'CAME TTS44RKS', subtitle: '4 canaux · 433.92 MHz · Rolling code',
      tags: [['Rolling code','green'],['433 MHz','purple'],['4 canaux','blue']],
      ref: 'FA01780M25',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_tts44rks_came.pdf',
      product: null },

    { id: 'came-tts44fks', brand: 'came', cat: 'telecommande', family: 'TTS',
      title: 'CAME TTS44FKS', subtitle: '4 canaux · 433.92 MHz · Code fixe',
      tags: [['Code fixe','orange'],['433 MHz','purple'],['4 canaux','blue']],
      ref: 'FA01755M25',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_tts44fks_came.pdf',
      product: null },

    { id: 'came-bx10', brand: 'came', cat: 'moteur_coul', family: 'BX',
      title: 'CAME BX-10', subtitle: 'Coulissant · Série BX',
      tags: [['Coulissant','blue'],['BX','gray']],
      ref: 'FA01137',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_bx10_came.pdf',
      product: null },

    { id: 'came-rgsm001', brand: 'came', cat: 'recepteur', family: 'RGSM',
      title: 'CAME RGSM001', subtitle: 'Module GSM · CAMEConnect · Télécommande à distance',
      tags: [['GSM','purple'],['CAMEConnect','blue'],['À distance','green']],
      ref: 'FA01022M4A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_rgsm001_came.pdf',
      product: null },

    { id: 'came-klt', brand: 'came', cat: 'clignotant', family: 'KLT',
      title: 'CAME KLT', subtitle: 'Clignotant LED · 24V AC/DC · Antenne intégrée bi-fréquence',
      tags: [['LED','green'],['24V','orange'],['Antenne intégrée','blue']],
      ref: '806LA-0060',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_klt_came.pdf',
      product: null },

    { id: 'came-krx', brand: 'came', cat: 'clignotant', family: 'KRX',
      title: 'CAME KRX', subtitle: 'Clignotant LED RGB · BUS CXN ou standard · Antenne intégrée',
      tags: [['RGB LED','green'],['BUS CXN','purple'],['Antenne intégrée','blue']],
      ref: '806LA-0010',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_krx_came.pdf',
      product: null },

    { id: 'came-kiaro', brand: 'came', cat: 'clignotant', family: 'KIARO',
      title: 'CAME KIARO (KLED / KLED24)', subtitle: 'Clignotant LED · 230V AC ou 24V AC/DC',
      tags: [['LED','green'],['230V / 24V','orange'],['IP54','blue']],
      ref: 'FA00628M4A',
      pdf: 'https://portail-systeme.fr/cdn/shop/files/notice_programmation_kiaro_came.pdf',
      product: null },
];

const BRANDS = [
    { id: 'all', label: 'Toutes' },
    { id: 'nice', label: 'Nice' },
    { id: 'came', label: 'CAME' },
    { id: 'faac', label: 'FAAC' },
    { id: 'somfy', label: 'Somfy' },
    { id: 'bft', label: 'BFT' },
    { id: 'cardin', label: 'Cardin' }
];

const BRAND_IDS = BRANDS.map(b => b.id).filter(id => id !== 'all');
const ACTIVE_CLASSES = BRAND_IDS.map(id => 'active-' + id);
const ALL_ACTIVE = ['active', ...ACTIVE_CLASSES];

let state = { cat: 'all', brand: 'all', query: '' };

function debounce(fn, ms) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), ms);
    };
}

function setBrandActive($container, brandId) {
    $container.querySelectorAll('.pill').forEach(b => {
        b.classList.remove(...ALL_ACTIVE);
        if (b.dataset.brand === brandId) {
            b.classList.add(brandId === 'all' ? 'active' : 'active-' + brandId);
        }
    });
}

function setCatActive($container, catId) {
    $container.querySelectorAll('.pill').forEach(b => {
        b.classList.remove('active');
        if (b.dataset.cat === catId) b.classList.add('active');
    });
}

let searchIndex;
function buildSearchIndex() {
    searchIndex = DOCS.map(d => ({
        doc: d,
        hay: `${d.title} ${d.subtitle} ${d.family} ${d.ref} ${d.tags.map(t => t[0]).join(' ')} ${d.cat} ${d.brand}`.toLowerCase()
    }));
}

function init() {
    buildSearchIndex();

    CATEGORIES.forEach(c => {
        c.count = c.id === 'all' ? DOCS.length : DOCS.filter(d => d.cat === c.id).length;
    });

    const $bp = document.getElementById('brandPills');
    $bp.innerHTML = BRANDS.map(b => {
        const count = b.id === 'all' ? DOCS.length : DOCS.filter(d => d.brand === b.id).length;
        return `<button class="pill ${b.id === 'all' ? 'active' : ''}" data-brand="${b.id}">${b.label}<span class="count">${count}</span></button>`;
    }).join('');

    const $cp = document.getElementById('catPills');
    $cp.innerHTML = CATEGORIES.filter(c => c.count > 0 || c.id === 'all').map(c =>
        `<button class="pill ${c.id === 'all' ? 'active' : ''}" data-cat="${c.id}">
            <span class="material-icons-round">${c.icon}</span>
            ${c.label}<span class="count">${c.count}</span>
        </button>`
    ).join('');

    $bp.addEventListener('click', e => {
        const btn = e.target.closest('.pill');
        if (!btn) return;
        state.brand = btn.dataset.brand;
        setBrandActive($bp, state.brand);
        render();
    });

    $cp.addEventListener('click', e => {
        const btn = e.target.closest('.pill');
        if (!btn) return;
        state.cat = btn.dataset.cat;
        setCatActive($cp, state.cat);
        render();
    });

    const $search = document.getElementById('searchInput');
    const $clear = document.getElementById('clearSearch');
    const $kbd = document.querySelector('.search-kbd');

    const debouncedRender = debounce(() => render(), 150);

    $search.addEventListener('input', () => {
        state.query = $search.value.trim().toLowerCase();
        $clear.classList.toggle('hidden', !state.query);
        if ($kbd) $kbd.classList.toggle('hidden', !!state.query);
        debouncedRender();
    });

    $clear.addEventListener('click', () => {
        $search.value = '';
        state.query = '';
        $clear.classList.add('hidden');
        if ($kbd) $kbd.classList.remove('hidden');
        render();
        $search.focus();
    });

    document.getElementById('clearFilters').addEventListener('click', () => {
        state = { cat: 'all', brand: 'all', query: '' };
        $search.value = '';
        $clear.classList.add('hidden');
        if ($kbd) $kbd.classList.remove('hidden');
        setBrandActive($bp, 'all');
        setCatActive($cp, 'all');
        render();
    });

    document.addEventListener('keydown', e => {
        if (e.key === '/' && document.activeElement !== $search) {
            e.preventDefault();
            $search.focus();
        }
        if (e.key === 'Escape') $search.blur();
    });

    document.querySelectorAll('[data-brand-jump]').forEach(el => {
        const b = el.dataset.brandJump;
        const count = DOCS.filter(d => d.brand === b).length;
        el.querySelector('.hero-brand-count').textContent = count + ' notices';
        el.addEventListener('click', e => {
            e.preventDefault();
            state.brand = b;
            setBrandActive($bp, b);
            render();
            document.getElementById('filtersNav').scrollIntoView({ behavior: 'smooth' });
        });
    });

    animateCounter('heroCount', DOCS.length, 800);

    const $header = document.querySelector('.header');
    if ($header) {
        const syncHeaderH = () => {
            document.documentElement.style.setProperty('--header-h', $header.offsetHeight + 'px');
        };
        syncHeaderH();
        window.addEventListener('resize', syncHeaderH);
    }

    const $btt = document.getElementById('backToTop');
    if ($btt) {
        let ticking = false;
        window.addEventListener('scroll', () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    $btt.classList.toggle('visible', window.scrollY > 400);
                    ticking = false;
                });
                ticking = true;
            }
        }, { passive: true });

        $btt.addEventListener('click', () => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    const $promo = document.querySelector('.promo-code');
    if ($promo) {
        $promo.addEventListener('click', () => {
            navigator.clipboard.writeText('GUIDE').then(() => {
                const tip = document.createElement('span');
                tip.className = 'promo-code-tooltip';
                tip.textContent = 'Copié !';
                $promo.appendChild(tip);
                setTimeout(() => tip.remove(), 1500);
            });
        });
    }

    render();
}

function animateCounter(elementId, target, duration) {
    const el = document.getElementById(elementId);
    if (!el) return;
    const start = performance.now();
    function step(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(eased * target);
        if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
}

function getFiltered() {
    return searchIndex.filter(({ doc, hay }) => {
        if (state.cat !== 'all' && doc.cat !== state.cat) return false;
        if (state.brand !== 'all' && doc.brand !== state.brand) return false;
        if (state.query && !hay.includes(state.query)) return false;
        return true;
    }).map(({ doc }) => doc);
}

const BRAND_NAMES = {
    nice: 'Nice', came: 'CAME', faac: 'FAAC',
    somfy: 'Somfy', bft: 'BFT', cardin: 'Cardin'
};

const BRAND_LOGOS = {
    nice: 'https://portail-systeme.fr/cdn/shop/files/nice.png',
    came: 'https://portail-systeme.fr/cdn/shop/files/came.png',
    faac: 'https://portail-systeme.fr/cdn/shop/files/faac.png',
    somfy: 'https://portail-systeme.fr/cdn/shop/files/somfy.png',
    bft: 'https://portail-systeme.fr/cdn/shop/files/bft.png',
    cardin: 'https://portail-systeme.fr/cdn/shop/files/cardin.png'
};

const BRAND_ALTS = {
    nice: 'Logo Nice',
    came: 'Logo CAME',
    faac: 'Logo FAAC',
    somfy: 'Logo Somfy',
    bft: 'Logo BFT',
    cardin: 'Logo Cardin'
};

function renderCard(d, i) {
    const tagsHtml = d.tags.map(([label, color]) => `<span class="tag tag-${color}">${label}</span>`).join('');
    const shopBtn = d.product
        ? `<a href="${d.product}" target="_blank" class="btn btn-shop ${d.brand}" title="Acheter ${d.title}"><span class="material-icons-round">shopping_cart</span></a>`
        : '';
    const delay = Math.min(i * 30, 600);
    const catLabel = CAT_SEO[d.cat] || '';
    const catIcon = CAT_ICONS[d.cat] || '';
    const seoTitle = `Notice programmation ${catLabel} ${d.title}`.trim();

    return `<article class="card ${d.brand}" id="${d.id}" style="animation-delay:${delay}ms">
        <div class="card-head">
            <span class="brand-dot ${d.brand}"></span>
            <div class="card-titles">
                <span class="card-seo-label"><span class="material-icons-round card-cat-icon">${catIcon}</span> Notice programmation ${catLabel}</span>
                <h3 class="card-title">${d.title}</h3>
                <p class="card-sub">${d.subtitle}</p>
                <p class="card-ref">Réf: ${d.ref}</p>
            </div>
        </div>
        <div class="card-tags">${tagsHtml}</div>
        <div class="card-actions">
            <a href="${d.pdf}" class="btn btn-pdf" target="_blank" title="${seoTitle}">
                <span class="material-icons-round">picture_as_pdf</span> Voir le PDF
            </a>
            ${shopBtn}
        </div>
    </article>`;
}

/* ============================================================
   HELPER : compte les docs du searchIndex selon des filtres
   partiels (permet de réutiliser la logique partout)
   ============================================================ */
function countDocs(filterBrand, filterCat, filterQuery) {
    return searchIndex.filter(({ doc, hay }) => {
        if (filterBrand !== 'all' && doc.brand !== filterBrand) return false;
        if (filterCat   !== 'all' && doc.cat   !== filterCat)   return false;
        if (filterQuery && !hay.includes(filterQuery))          return false;
        return true;
    }).length;
}

function render() {
    const filtered = getFiltered();
    const isFiltered = state.cat !== 'all' || state.brand !== 'all' || state.query;
    const $grid = document.getElementById('docsGrid');
    const $empty = document.getElementById('emptyState');
    const $count = document.getElementById('resultCount');
    const $clearBtn = document.getElementById('clearFilters');

    $clearBtn.classList.toggle('hidden', !isFiltered);

    /* ====================================================================
       FIX : Mise à jour dynamique des compteurs des pills
       ====================================================================
       Les compteurs reflètent maintenant le nombre de résultats
       possibles si l'utilisateur cliquait sur ce pill, en tenant
       compte des autres filtres déjà actifs.
       ==================================================================== */

    // Compteurs des pills CATÉGORIES (filtrés par brand + query actuels)
    document.querySelectorAll('#catPills .pill').forEach(btn => {
        const catId = btn.dataset.cat;
        const count = countDocs(state.brand, catId, state.query);
        btn.querySelector('.count').textContent = count;
    });

    // Compteurs des pills MARQUES (filtrés par cat + query actuels)
    document.querySelectorAll('#brandPills .pill').forEach(btn => {
        const brandId = btn.dataset.brand;
        const count = countDocs(brandId, state.cat, state.query);
        btn.querySelector('.count').textContent = count;
    });

    /* ==================================================================== */

    $count.textContent = isFiltered
        ? `${filtered.length} résultat${filtered.length !== 1 ? 's' : ''} sur ${DOCS.length}`
        : `${DOCS.length} notices disponibles`;

    if (filtered.length === 0) {
        $grid.innerHTML = '';
        $empty.classList.remove('hidden');
        return;
    }
    $empty.classList.add('hidden');

    const showBrandHeadings = !state.query;
    let html = '';
    let cardIndex = 0;

    if (showBrandHeadings) {
        const brandOrder = ['nice', 'came', 'faac', 'somfy', 'bft', 'cardin'];
        brandOrder.forEach(brandId => {
            const brandDocs = filtered.filter(d => d.brand === brandId);
            if (brandDocs.length === 0) return;
            const catSuffix = state.cat !== 'all'
                ? ` — <span class="material-icons-round section-cat-icon">${CAT_ICONS[state.cat]}</span> ${CATEGORIES.find(c => c.id === state.cat)?.label || ''}`
                : '';
            html += `<h2 class="section-heading" id="section-${brandId}">
                <img src="${BRAND_LOGOS[brandId]}" alt="${BRAND_ALTS[brandId]}" class="section-brand-logo">
                Notices de programmation ${BRAND_NAMES[brandId]}${catSuffix}
                <span class="section-count">${brandDocs.length}</span>
            </h2>`;
            html += brandDocs.map(d => renderCard(d, cardIndex++)).join('');
        });
    } else {
        html = filtered.map((d, i) => renderCard(d, i)).join('');
    }

    $grid.innerHTML = html;
}

document.addEventListener('DOMContentLoaded', init);